import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, observable, makeObservable, runInAction, action, reaction } from "mobx";
import CreditCardModel from "./models/CreditCardModel";
import GiftCardModel from "./models/GiftCardModel";
import GratuityModel from "./models/GratuityModel";
import DPServices from "@dp/services";
import * as common from "@dp/common";
import CouponModel from "./models/CouponModel";
import * as utils from "../utils";
import { encryptAccount } from "../utils/encryption";
import moment from "moment-timezone";
import Errors, { ERROR_STRINGS } from "./Errors";
import BrandRules from "../utils/BrandRules";
/*
Sample Order Price Info (Order Response - No Coupon)
------------------------
amount: 23.49
currencyCode: "USD"
discountAmount: 0
rawSubtotal: 23.49
shipping: 0
tax: 2.08
total: 25.57

Sample Order Price Info (Order Response - Post Coupon)
------------------------
amount: 21.14
currencyCode: "USD"
discountAmount: 2.349999999999998
rawSubtotal: 23.49
shipping: 0
tax: 1.88
total: 23.02

amount = rawSubtotal - discountAmount
total = amount + tax
*/

var Payment = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Payment, _Base);

  var _super = _createSuper(Payment); //if user needs to re-enter CVV for a saved card


  function Payment(rootStore) {
    var _this;

    _classCallCheck(this, Payment);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_rsaFlowEnabled", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_userProfile", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_activePaymentTab", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_activeOtherOptionTab", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_giftCards", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_creditCards", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_subTotalWithoutItemDiscount", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_paymentCVV", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_componentRef", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_paymentCVVEnabled", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionToken", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_rsaToken", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_validateToken", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_encryptionFields", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isCCPaymentDisabled", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_payPalErrored", _descriptor17, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePayErrored", _descriptor18, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_googlePayErrored", _descriptor19, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGCFailureLimitReached", _descriptor20, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "gratuityModel", null);

    _defineProperty(_assertThisInitialized(_this), "creditCardInfo", null);

    _defineProperty(_assertThisInitialized(_this), "couponModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "giftCardInfo", _descriptor21, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_payPalData", _descriptor22, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_savedGiftCardsLimit", _descriptor23, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_orderPriceInfo", _descriptor24, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_tippableAmount", _descriptor25, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_formSubmitted", _descriptor26, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isPayPalEnabled", _descriptor27, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGooglePayEnabled", _descriptor28, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isApplePayEnabled", _descriptor29, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isGiftCardPaymentEnabled", _descriptor30, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_allowedPaymentMethods", _descriptor31, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_giftCardRecaptchaSiteKey", _descriptor32, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePaySession", _descriptor33, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_applePayAuthorization", _descriptor34, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_googlePayAuthorization", _descriptor35, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_fallbackReasonCode", _descriptor36, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_flow", _descriptor37, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_maximumGCAllowedPerOrder", _descriptor38, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_errorsYPosition", _descriptor39, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showError", _descriptor40, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_requestPhoneNumberFromAppleOrGooglePay", _descriptor41, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_orderSessionRSARetryCount", _descriptor42, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_requestShippingFieldsFromAppleOrGooglePay", _descriptor43, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "setErrorsYPosition", function (code, yPos) {
      runInAction(function () {
        _this._errorsYPosition[code] = yPos;
      });
    });

    _this.rootStore = rootStore;
    _this.gratuityModel = new GratuityModel(_this.rootStore.platformUtil);
    _this.creditCardInfo = new CreditCardModel(true, true);
    _this.giftCardInfo = new GiftCardModel();
    _this.couponModel = new CouponModel();
    runInAction(function () {
      _this._activePaymentTab = utils.PaymentMethods.ONLINE;
      _this._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
      _this._giftCards = [];
      _this._creditCards = [];
      _this._paymentCVV = "";
      _this.appMessages = rootStore.appMessages;
    });
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Payment, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2._processAppAttributes(data.appAttributes);
      }); //user-profile

      reaction(function () {
        return {
          userProfile: _this2.rootStore.user.userProfile,
          isLoggedIn: _this2.rootStore.user.isLoggedIn
        };
      }, function (data) {
        _this2._processUserProfile(data.isLoggedIn, data.userProfile);
      });
    }
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      if (isLoggedIn && userProfile) {
        this.creditCardInfo.fullAVSEnabled = true;
        this.creditCardInfo.saveCreditCard = true;
        this.creditCardInfo.saveCardMandateEnabled = true;
        this.creditCardInfo.agreeDisclaimer = true;
        this.userProfile = userProfile;
      }
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this3 = this;

      if (appAttributes) {
        var appConfig = appAttributes.configs;
        var paymentCVV_enabled = appConfig.paymentCVV_enabled;

        if (paymentCVV_enabled) {
          this.paymentCVVEnabled = paymentCVV_enabled === "true" ? true : false;
        }

        this.savedGiftCardsLimit = appAttributes.SavedGiftCardMaxLimit;
        this.rsaFlowEnabled = appAttributes.configs.rsaFlowEnabled === "true";
      }

      if (appAttributes !== null && appAttributes !== void 0 && appAttributes.configs) {
        runInAction(function () {
          _this3._giftCardRecaptchaSiteKey = appAttributes.configs.gcbalance_captcha_public_key;
        });
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$rootStore, _this$rootStore$user, _this$rootStore2, _this$rootStore2$user;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.reset();
                _context.next = 3;
                return common.handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["GRATUITY_INFO"].join("-"), this.gratuityModel));

              case 3:
                this._processAppAttributes(this.rootStore.common.appAttributes);

                this._processUserProfile((_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.isLoggedIn, (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.userProfile);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                runInAction(function () {
                  var _this4$creditCardInfo, _this4$couponModel;

                  _this4._rsaFlowEnabled = false;
                  _this4._paymentCVVEnabled = false;
                  _this4._isCCPaymentDisabled = false;
                  _this4._payPalErrored = false;
                  _this4._applePayErrored = false;
                  _this4._googlePayErrored = false;
                  _this4._savedGiftCardsLimit = null;
                  _this4._formSubmitted = false;
                  _this4._isPayPalEnabled = false;
                  _this4._isGooglePayEnabled = false;
                  _this4._isApplePayEnabled = false;
                  _this4._isGiftCardPaymentEnabled = true;
                  _this4._allowedPaymentMethods = "PAY_ONLINE";
                  _this4._maximumGCAllowedPerOrder = null;
                  _this4._activePaymentTab = utils.PaymentMethods.ONLINE;
                  _this4._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
                  _this4._paymentCVV = "";
                  _this4._requestPhoneNumberFromAppleOrGooglePay = true;
                  _this4._requestShippingFieldsFromAppleOrGooglePay = true;
                  (_this4$creditCardInfo = _this4.creditCardInfo) === null || _this4$creditCardInfo === void 0 ? void 0 : _this4$creditCardInfo.resetCreditCardModel();
                  (_this4$couponModel = _this4.couponModel) === null || _this4$couponModel === void 0 ? void 0 : _this4$couponModel.resetModel();
                  _this4._orderSessionRSARetryCount = common.toInteger(common.getEnvProps()["NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT"], 2);
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this5 = this;

      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      appMessages.showError("Missing Details", this.activeOtherOptionTab === utils.OnlinePaymentTypes.NONE ? "Please select a Payment method." : "Please enter all required fields.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this5.rootStore.platformUtil.scrollToElement(_this5.componentRef, isMobile ? 50 : 0);
        }
      });
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for missing payment",
        modalContent: "Error modal for missing payment",
        modalName: "PaymentInfo-Error-Modal"
      });
    }
  }, {
    key: "showMaxGCExceededPopup",
    value: function showMaxGCExceededPopup() {
      this.appMessages.showError("Max ".concat(this.maximumGCAllowedPerOrder, " gift card(s) allowed per order"), "You can only select ".concat(this.maximumGCAllowedPerOrder, " gift card(s) for online payment of this order. If you would like to use more than ").concat(this.maximumGCAllowedPerOrder, " gift card(s) please contact your server."), null, {
        okBtnText: "OK"
      });
    }
  }, {
    key: "addNewGiftCard",
    value: function addNewGiftCard() {
      var isSavedCard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var rawGiftCardNumber = this.giftCardInfo.gcNumber.replace(/-/g, "");

      if (rawGiftCardNumber) {
        var filtered = this._giftCards.filter(function (gc) {
          return gc.card.giftCardNumber === rawGiftCardNumber;
        });

        var uiCard = {
          card: {
            giftCardBalance: this.giftCardInfo.gcBalance,
            giftCardInfoId: this.giftCardInfo.giftCardID || moment().toDate().getTime(),
            giftCardName: this.giftCardInfo.rawGCNumber,
            giftCardNumber: this.giftCardInfo.rawGCNumber
          },
          amountUsed: 0,
          proratedAmount: 0,
          proratedTip: 0,
          selectionOrder: 0,
          isVisible: true,
          isSelected: false,
          isDisabled: false,
          isSavedCard: isSavedCard
        };

        if (filtered.length === 0) {
          this._giftCards.push(uiCard);
        }

        if (!this.isMaxGCLimit) {
          this.selectGiftCard(uiCard, true);
        }

        this.giftCardInfo = new GiftCardModel();
      }

      return true;
    }
  }, {
    key: "clearGiftCard",
    value: function clearGiftCard() {
      this.giftCardInfo = new GiftCardModel();
    }
  }, {
    key: "setGiftCards",
    value: function setGiftCards(savedGiftCards) {
      var _this6 = this;

      runInAction(function () {
        _this6._giftCards = savedGiftCards ? savedGiftCards.map(function (savedCard) {
          return {
            card: savedCard,
            amountUsed: 0,
            proratedAmount: 0,
            proratedTip: 0,
            isDisabled: savedCard.giftCardBalance <= 0,
            isSelected: false,
            isVisible: true,
            selectionOrder: 0,
            isSavedCard: true
          };
        }) : [];
      });
    }
  }, {
    key: "selectGiftCard",
    value: function selectGiftCard(card, checked) {
      var _this7 = this;

      runInAction(function () {
        var selCard = _this7._giftCards.find(function (item) {
          return item.card.giftCardNumber === card.card.giftCardNumber;
        });

        selCard.isSelected = checked;

        if (checked) {
          var list = _this7._giftCards.map(function (gCard) {
            return gCard.selectionOrder;
          }); // eslint-disable-next-line prefer-spread


          var maxSelOrderInArr = Math.max.apply(Math, list);
          selCard.selectionOrder = maxSelOrderInArr + 1;
        }
      });
    }
  }, {
    key: "setCreditCards",
    value: function setCreditCards(savedCreditCards) {
      var _this8 = this;

      runInAction(function () {
        _this8._creditCards = savedCreditCards ? savedCreditCards.map(function (savedCard, i) {
          return {
            index: i,
            card: savedCard,
            proratedAmount: 0,
            proratedTip: 0,
            isDisabled: false,
            isSelected: false,
            isVisible: true,
            paymentCVV: null,
            hasExpired: _this8._hasExpired(savedCard),
            isDefault: _this8.userProfile.defaultCreditCardPaymentToken === savedCard.paymentCardToken
          };
        }) : [];
      });
    }
  }, {
    key: "_hasExpired",
    value: function _hasExpired(card) {
      try {
        var creditCardDate = moment(card.expirationYear + card.expirationMonth, "YYMM");
        var today = moment();
        return creditCardDate.isValid() && today > creditCardDate.add(1, "months");
      } catch (err) {
        return true;
      }
    }
  }, {
    key: "selectCreditCard",
    value: function selectCreditCard(card) {
      this._creditCards = this._creditCards.map(function (item) {
        if (card.card.paymentCardToken === item.card.paymentCardToken) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      });
      this._activeOtherOptionTab = utils.OnlinePaymentTypes.NONE;
    }
  }, {
    key: "deSelectCreditCards",
    value: function deSelectCreditCards() {
      if (this._creditCards.length) {
        this._creditCards = this._creditCards.map(function (item) {
          item.isSelected = false;
          return item;
        });
      }
    }
  }, {
    key: "deSelectGiftCards",
    value: function deSelectGiftCards() {
      if (this._giftCards.length) {
        this._giftCards = this._giftCards.map(function (item) {
          item.isSelected = false;
          return item;
        });
      }
    }
  }, {
    key: "removeGiftCard",
    value: function removeGiftCard(uiCard) {
      var remainingCards = [];

      this._giftCards.forEach(function (card) {
        if (card.card.giftCardNumber !== uiCard.card.giftCardNumber) {
          remainingCards.push(card);
        }
      });

      this._giftCards = remainingCards;
    }
  }, {
    key: "getAuthAndTipAmounts",
    value: function getAuthAndTipAmounts(totalAmount, tipPercent) {
      var totalProratedTip = totalAmount * tipPercent;

      if (totalProratedTip > totalAmount) {
        return {
          authAmount: 0.01,
          tipAmount: common.roundTo(totalAmount, 2) - 0.01
        };
      } else {
        return {
          authAmount: common.roundTo(totalAmount - totalProratedTip, 2),
          tipAmount: common.roundTo(totalProratedTip, 2)
        };
      }
    }
  }, {
    key: "getApplePayMerchantSession",
    value: function () {
      var _getApplePayMerchantSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(validationUrl) {
        var _common$getEnvProps, NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV, DEVELOPMENT, _yield$common$handle, _yield$common$handle2, err, resp, _yield$common$handle3, _yield$common$handle4, _err, _resp;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _common$getEnvProps = common.getEnvProps(), NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;
                DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";

                if (!DEVELOPMENT) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 5;
                return common.handle(DPServices.Payment.getApplePaySessionToken(this.rootStore.platformUtil.getHostName(), null));

              case 5:
                _yield$common$handle = _context4.sent;
                _yield$common$handle2 = _slicedToArray(_yield$common$handle, 2);
                err = _yield$common$handle2[0];
                resp = _yield$common$handle2[1];

                if (!err) {
                  _context4.next = 13;
                  break;
                }

                throw err;

              case 13:
                return _context4.abrupt("return", resp);

              case 14:
                _context4.next = 27;
                break;

              case 16:
                _context4.next = 18;
                return common.handle(DPServices.Payment.getApplePaySessionToken(null, validationUrl));

              case 18:
                _yield$common$handle3 = _context4.sent;
                _yield$common$handle4 = _slicedToArray(_yield$common$handle3, 2);
                _err = _yield$common$handle4[0];
                _resp = _yield$common$handle4[1];

                if (!_err) {
                  _context4.next = 26;
                  break;
                }

                throw _err;

              case 26:
                return _context4.abrupt("return", _resp);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getApplePayMerchantSession(_x) {
        return _getApplePayMerchantSession.apply(this, arguments);
      }

      return getApplePayMerchantSession;
    }()
  }, {
    key: "getGiftCardBalance",
    value: function () {
      var _getGiftCardBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var errMessage, gcCheckBalFromCheckout, _yield$common$handle5, _yield$common$handle6, err, data, _errObj$response, _DPServices$Cart$pars, _DPServices$Cart$pars2, _errObj$response2, _errObj$response2$dat, errObj, faults;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                errMessage = "Sorry, We are unable to process your request at this time. Please try again later.";
                gcCheckBalFromCheckout = true;
                _context5.next = 4;
                return common.handle(DPServices.Payment.getGiftCardBalance(this.giftCardInfo.gcNumber, this.giftCardInfo.captchaToken, gcCheckBalFromCheckout));

              case 4:
                _yield$common$handle5 = _context5.sent;
                _yield$common$handle6 = _slicedToArray(_yield$common$handle5, 2);
                err = _yield$common$handle6[0];
                data = _yield$common$handle6[1];

                if (!err) {
                  _context5.next = 16;
                  break;
                }

                errObj = err;
                faults = (errObj === null || errObj === void 0 ? void 0 : (_errObj$response = errObj.response) === null || _errObj$response === void 0 ? void 0 : _errObj$response.status) === 400 ? (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj.response.data)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults : (_DPServices$Cart$pars2 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars2 === void 0 ? void 0 : _DPServices$Cart$pars2.faults;
                this.giftCardInfo.errorMessage = faults && faults[0] && faults[0].faultDescription || errMessage;
                this.isGCFailureLimitReached = errObj === null || errObj === void 0 ? void 0 : (_errObj$response2 = errObj.response) === null || _errObj$response2 === void 0 ? void 0 : (_errObj$response2$dat = _errObj$response2.data) === null || _errObj$response2$dat === void 0 ? void 0 : _errObj$response2$dat.disableGiftCardOption;
                throw err;

              case 16:
                if (!(data.giftCardBalance > 0)) {
                  _context5.next = 21;
                  break;
                }

                this.giftCardInfo.gcBalance = data.giftCardBalance;
                this.giftCardInfo.errorMessage = "";
                _context5.next = 28;
                break;

              case 21:
                if (!(data.giftCardBalance === 0)) {
                  _context5.next = 26;
                  break;
                }

                this.giftCardInfo.errorMessage = "No available balance on the card";
                throw new Error("No available balance on the card");

              case 26:
                this.giftCardInfo.errorMessage = errMessage;
                throw new Error(errMessage);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getGiftCardBalance() {
        return _getGiftCardBalance.apply(this, arguments);
      }

      return getGiftCardBalance;
    }()
  }, {
    key: "saveGiftCardToProfile",
    value: function () {
      var _saveGiftCardToProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this9 = this;

        var _yield$common$handle7, _yield$common$handle8, err, resp, _DPServices$Cart$pars3, errObj, faults, cardNo, maskedCardNo, newGiftCardNumber, newRawGiftCardNumber;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!this.canAddGiftCard) {
                  _context6.next = 24;
                  break;
                }

                _context6.next = 4;
                return common.handle(DPServices.User.saveGiftCardToProfile(this.giftCardInfo.gcNumber, this.giftCardInfo.gcNumber));

              case 4:
                _yield$common$handle7 = _context6.sent;
                _yield$common$handle8 = _slicedToArray(_yield$common$handle7, 2);
                err = _yield$common$handle8[0];
                resp = _yield$common$handle8[1];

                if (!err) {
                  _context6.next = 17;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars3 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars3 === void 0 ? void 0 : _DPServices$Cart$pars3.faults;
                this.giftCardInfo.errorMessage = faults && faults[0] && faults[0].faultDescription;

                if (!this.giftCardInfo.errorMessage) {
                  _context6.next = 16;
                  break;
                }

                throw new Error(this.giftCardInfo.errorMessage);

              case 16:
                throw Errors.SAVE_GIFT_CARD_TO_PROFILE_FAILED;

              case 17:
                cardNo = this.giftCardInfo.gcNumber;
                maskedCardNo = cardNo.substring(cardNo.length - 4, cardNo.length);
                this.appMessages.showSuccess("Gift Card Added", "The gift card ending ".concat(maskedCardNo, " is successfully added to your profile"));
                this.giftCardInfo.saveGiftCardToProfile = false;
                newGiftCardNumber = this.giftCardInfo.gcNumber;
                newRawGiftCardNumber = newGiftCardNumber.replace(/-/g, "");
                resp.forEach(function (gc) {
                  if (newRawGiftCardNumber === gc.giftCardNumber) {
                    _this9.giftCardInfo.gcBalance = gc.giftCardBalance;
                    _this9.giftCardInfo.giftCardID = gc.giftCardInfoId;
                    _this9.giftCardInfo.gcNumber = gc.giftCardName;
                    _this9.giftCardInfo.gcNumber = gc.giftCardNumber;

                    _this9.addNewGiftCard(true);
                  }
                });

              case 24:
                _context6.next = 30;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t0 = _context6["catch"](0);
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context6.t0.message);
                throw new Error(_context6.t0.message);

              case 30:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 26]]);
      }));

      function saveGiftCardToProfile() {
        return _saveGiftCardToProfile.apply(this, arguments);
      }

      return saveGiftCardToProfile;
    }()
  }, {
    key: "tokenizeCreditCardPayment",
    value: function () {
      var _tokenizeCreditCardPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(merchantId, paymentCorrelationId, orderId, sessionTokenSource) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.rsaFlowEnabled) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 3;
                return this.tokenizeCreditCardPaymentRSA(paymentCorrelationId, orderId, merchantId, sessionTokenSource);

              case 3:
                _context7.next = 7;
                break;

              case 5:
                _context7.next = 7;
                return this.tokenizeCreditCardPaymentLegacy(paymentCorrelationId, orderId, sessionTokenSource);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function tokenizeCreditCardPayment(_x2, _x3, _x4, _x5) {
        return _tokenizeCreditCardPayment.apply(this, arguments);
      }

      return tokenizeCreditCardPayment;
    }()
  }, {
    key: "tokenizeCreditCardPaymentLegacy",
    value: function () {
      var _tokenizeCreditCardPaymentLegacy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(paymentCorrelationId, orderId, sessionTokenSource) {
        var _common$getEnvProps2, NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT, NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT, _ref, _ref2, orderSessionTokenErr, orderSessionToken, _err$response, _err$response$data, err, fault, sessionToken, account, payload, _yield$common$handle9, _yield$common$handle10, payTokenErr, paymentToken, reqPayload, isBusinessFault, _err2, _reqError$response, reqError, responseData, _responseData, tokenData;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _common$getEnvProps2 = common.getEnvProps(), NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT = _common$getEnvProps2.NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT, NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT = _common$getEnvProps2.NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT;

                if (this.sessionToken) {
                  _context8.next = 42;
                  break;
                }

                if (!(sessionTokenSource === "MOBILE_PAY")) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 5;
                return common.handle(DPServices.Payment.getMobilePaySessionToken("agentID", paymentCorrelationId, common.toInteger(NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT, 2)));

              case 5:
                _context8.t0 = _context8.sent;
                _context8.next = 18;
                break;

              case 8:
                if (!(sessionTokenSource === "TOGO")) {
                  _context8.next = 14;
                  break;
                }

                _context8.next = 11;
                return common.handle(DPServices.Payment.getOrdersSessionToken("agentID", paymentCorrelationId, common.toInteger(NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT, 2)));

              case 11:
                _context8.t1 = _context8.sent;
                _context8.next = 17;
                break;

              case 14:
                _context8.next = 16;
                return common.handle(DPServices.Payment.getGiftCardOrderSessionToken("agentID", paymentCorrelationId, common.toInteger(NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_RETRY_COUNT, 2)));

              case 16:
                _context8.t1 = _context8.sent;

              case 17:
                _context8.t0 = _context8.t1;

              case 18:
                _ref = _context8.t0;
                _ref2 = _slicedToArray(_ref, 2);
                orderSessionTokenErr = _ref2[0];
                orderSessionToken = _ref2[1];

                if (!orderSessionTokenErr) {
                  _context8.next = 40;
                  break;
                }

                err = orderSessionTokenErr;

                if (!((_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.fault)) {
                  _context8.next = 35;
                  break;
                }

                fault = err.response.data.fault;

                if (!(fault.faultCode === "CHECK_NOT_LOADED")) {
                  _context8.next = 30;
                  break;
                }

                throw common.ERRORS.CHECK_NOT_LOADED;

              case 30:
                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 33:
                _context8.next = 38;
                break;

              case 35:
                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 38:
                _context8.next = 42;
                break;

              case 40:
                this.isCCPaymentDisabled = false;
                this.sessionToken = orderSessionToken;

              case 42:
                sessionToken = this.sessionToken;

                if (!(sessionToken && sessionToken.sessionToken)) {
                  _context8.next = 70;
                  break;
                }

                account = this.creditCardInfo.cardAccount;
                payload = {
                  account: account,
                  paymentTokenType: this.creditCardInfo.saveCreditCard ? "LONGTERM" : "ONETIME"
                };
                _context8.next = 48;
                return common.handle(DPServices.Payment.getPaymentToken(sessionToken, payload, common.toInteger(NEXT_PUBLIC_REACT_APP_BAMS_API_RETRY_COUNT, 3)));

              case 48:
                _yield$common$handle9 = _context8.sent;
                _yield$common$handle10 = _slicedToArray(_yield$common$handle9, 2);
                payTokenErr = _yield$common$handle10[0];
                paymentToken = _yield$common$handle10[1];

                if (!(paymentToken && paymentToken.paymentToken)) {
                  _context8.next = 57;
                  break;
                }

                this.sessionToken = null;
                this.creditCardInfo.paymentToken = paymentToken;
                _context8.next = 70;
                break;

              case 57:
                reqPayload = this.getTokenizationFailureLogRequest(orderId);
                isBusinessFault = false;

                if (payTokenErr) {
                  _err2 = payTokenErr;

                  if (_err2.response) {
                    //Axios Error
                    reqError = _err2;
                    responseData = (_reqError$response = reqError.response) === null || _reqError$response === void 0 ? void 0 : _reqError$response.data;
                    reqPayload.errorCode = reqError === null || reqError === void 0 ? void 0 : reqError.response.status;
                    reqPayload.errorDescription = (reqError === null || reqError === void 0 ? void 0 : reqError.response.statusText) || "";
                    reqPayload.ResultCode = (responseData === null || responseData === void 0 ? void 0 : responseData.code) + "";
                    reqPayload.ResultMessage = responseData === null || responseData === void 0 ? void 0 : responseData.message;
                    isBusinessFault = DPServices.Payment.isBusinessFault(responseData);
                  } else {
                    _responseData = _err2;
                    reqPayload.errorCode = null;
                    reqPayload.errorDescription = "";
                    reqPayload.ResultCode = (_responseData === null || _responseData === void 0 ? void 0 : _responseData.code) + "";
                    reqPayload.ResultMessage = _responseData === null || _responseData === void 0 ? void 0 : _responseData.message;
                    isBusinessFault = DPServices.Payment.isBusinessFault(_responseData);
                  }
                } else if (paymentToken) {
                  tokenData = paymentToken;
                  reqPayload.ResultCode = tokenData.code;
                  reqPayload.ResultMessage = tokenData.message;
                  reqPayload.errorCode = tokenData.code || "";
                  reqPayload.errorDescription = tokenData.message || "";
                } else {// Default
                }

                _context8.next = 62;
                return common.handle(DPServices.Payment.logCCTokenizationFailure(reqPayload));

              case 62:
                this.creditCardInfo.paymentToken = null;
                this.sessionToken = null;

                if (!isBusinessFault) {
                  _context8.next = 68;
                  break;
                }

                throw common.ERRORS.CC_TOKENIZATION_BUSINESS_FAULT;

              case 68:
                this.isCCPaymentDisabled = true;
                throw common.ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE;

              case 70:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function tokenizeCreditCardPaymentLegacy(_x6, _x7, _x8) {
        return _tokenizeCreditCardPaymentLegacy.apply(this, arguments);
      }

      return tokenizeCreditCardPaymentLegacy;
    }()
  }, {
    key: "tokenizeCreditCardPaymentRSA",
    value: function () {
      var _tokenizeCreditCardPaymentRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(paymentCorrelationId, orderId, merchantId, sessionTokenSource) {
        var _orderRSAToken$status;

        var _yield$common$handle11, _yield$common$handle12, orderRSATokenErr, orderRSATokenResponse, orderRSAToken, _err$response2, _err$response2$data, err, fault, rsaToken, encryptionFields, expiryDate, billingAddressFullAVS, billingAddressPartialAVS, isPartialAVS, billingAddress, cardType, cardTypeCORS, credit, type, account, referenceToken, payload, _yield$common$handle13, _yield$common$handle14, payTokenErr, paymentToken, reqPayload, isBusinessFault, _err3;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return common.handle(DPServices.Payment.getRSAToken(utils.RSATokenTransactionType[sessionTokenSource], paymentCorrelationId, this.orderSessionRSARetryCount));

              case 2:
                _yield$common$handle11 = _context9.sent;
                _yield$common$handle12 = _slicedToArray(_yield$common$handle11, 2);
                orderRSATokenErr = _yield$common$handle12[0];
                orderRSATokenResponse = _yield$common$handle12[1];
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;

                if (!(orderRSATokenErr || orderRSAToken.status === "FAILURE" || ((_orderRSAToken$status = orderRSAToken.status) === null || _orderRSAToken$status === void 0 ? void 0 : _orderRSAToken$status.toUpperCase()) === "ERROR")) {
                  _context9.next = 26;
                  break;
                } // all the retry attempts are already exhausted by RSAToken API


                this.orderSessionRSARetryCount = 0;

                if (!orderRSATokenErr) {
                  _context9.next = 21;
                  break;
                }

                err = orderRSATokenErr;

                if (!((_err$response2 = err.response) !== null && _err$response2 !== void 0 && (_err$response2$data = _err$response2.data) !== null && _err$response2$data !== void 0 && _err$response2$data.fault)) {
                  _context9.next = 21;
                  break;
                }

                fault = err.response.data.fault;

                if (!(fault.faultCode === "CHECK_NOT_LOADED")) {
                  _context9.next = 18;
                  break;
                }

                throw common.ERRORS.CHECK_NOT_LOADED;

              case 18:
                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 21:
                this.isCCPaymentDisabled = true;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 26:
                this.isCCPaymentDisabled = false;
                this.rsaToken = orderRSAToken;

              case 28:
                rsaToken = this.rsaToken;

                if (!(rsaToken && rsaToken.publicKey && rsaToken.tokenId)) {
                  _context9.next = 84;
                  break;
                }

                encryptionFields = {
                  securityCode: this.creditCardInfo.cardAccountRSA.credit.securityCode,
                  paymentCardToken: this.creditCardInfo.cardAccountRSA.credit.cardNumber,
                  expirationMonth: this.creditCardInfo.cardAccountRSA.credit.expiryDate.month,
                  expirationYear: this.creditCardInfo.cardAccountRSA.credit.expiryDate.year
                };
                _context9.next = 33;
                return common.handle(encryptAccount(encryptionFields, rsaToken));

              case 33:
                // Assemble Payload for PaymentTokenRequestRSA
                expiryDate = {
                  year: encryptionFields.expirationYear,
                  month: encryptionFields.expirationMonth
                };
                billingAddressFullAVS = this.creditCardInfo.cardAccountRSA.credit.billingAddress;
                billingAddressPartialAVS = {
                  postalCode: this.creditCardInfo.cardAccountRSA.credit.billingAddress.postalCode
                };
                isPartialAVS = this.creditCardInfo.cardAccountRSA.credit.billingAddress.streetAddress === null || this.creditCardInfo.cardAccountRSA.credit.billingAddress.streetAddress === undefined; // Only send zip code in case of partial AVS

                billingAddress = isPartialAVS ? billingAddressPartialAVS : billingAddressFullAVS;
                cardType = this.creditCardInfo.cardAccountRSA.credit.cardType.toLowerCase();
                cardTypeCORS = "VISA";
                _context9.t0 = cardType;
                _context9.next = _context9.t0 === "mastercard" ? 43 : _context9.t0 === "american-express" ? 45 : _context9.t0 === "amex" ? 47 : _context9.t0 === "discover" ? 49 : _context9.t0 === "jcb" ? 51 : _context9.t0 === "diners-club" ? 53 : 55;
                break;

              case 43:
                cardTypeCORS = "MASTERCARD";
                return _context9.abrupt("break", 56);

              case 45:
                cardTypeCORS = "AMEX";
                return _context9.abrupt("break", 56);

              case 47:
                cardTypeCORS = "AMEX";
                return _context9.abrupt("break", 56);

              case 49:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 56);

              case 51:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 56);

              case 53:
                cardTypeCORS = "DISCOVER";
                return _context9.abrupt("break", 56);

              case 55:
                return _context9.abrupt("break", 56);

              case 56:
                credit = {
                  securityCode: encryptionFields.securityCode,
                  cardType: cardTypeCORS,
                  expiryDate: expiryDate,
                  cardNumber: encryptionFields.paymentCardToken,
                  nameOnCard: this.creditCardInfo.cardAccountRSA.credit.nameOnCard,
                  billingAddress: billingAddress
                };
                type = "CREDIT";
                account = {
                  type: type,
                  credit: credit
                };
                referenceToken = {
                  tokenType: "TRANS_ARMOR"
                };
                payload = {
                  merchantId: merchantId,
                  account: account,
                  referenceToken: referenceToken
                };
                _context9.next = 63;
                return common.handle(DPServices.Payment.getPaymentTokenRSA(rsaToken, payload));

              case 63:
                _yield$common$handle13 = _context9.sent;
                _yield$common$handle14 = _slicedToArray(_yield$common$handle13, 2);
                payTokenErr = _yield$common$handle14[0];
                paymentToken = _yield$common$handle14[1];

                if (!(paymentToken && paymentToken.paymentToken)) {
                  _context9.next = 72;
                  break;
                }

                this.sessionToken = null;
                this.creditCardInfo.paymentToken = paymentToken;
                _context9.next = 84;
                break;

              case 72:
                reqPayload = this.getTokenizationFailureLogRequestRSA(orderId);
                _context9.next = 75;
                return common.handle(DPServices.Payment.logCCTokenizationFailure(reqPayload));

              case 75:
                this.creditCardInfo.paymentToken = null;
                this.sessionToken = null;

                if (payTokenErr) {
                  _err3 = payTokenErr;

                  if (_err3.response) {
                    // Axios Error (CORS error) = Technical Fault
                    isBusinessFault = false;
                  } else {
                    // 400 Error = Business Fault
                    isBusinessFault = true;
                  }
                } else {
                  isBusinessFault = true;
                }

                if (!isBusinessFault) {
                  _context9.next = 82;
                  break;
                }

                throw common.ERRORS.CC_TOKENIZATION_BUSINESS_FAULT;

              case 82:
                this.isCCPaymentDisabled = true;
                throw common.ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE;

              case 84:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function tokenizeCreditCardPaymentRSA(_x9, _x10, _x11, _x12) {
        return _tokenizeCreditCardPaymentRSA.apply(this, arguments);
      }

      return tokenizeCreditCardPaymentRSA;
    }()
  }, {
    key: "getTokenizationFailureLogRequest",
    value: function getTokenizationFailureLogRequest(orderId) {
      var _card$cardNumber, _cardNumberValidation;

      var sessionToken = this.sessionToken;
      var formCCPaymentPayload = this.formCCPaymentPayload;
      var gcPaymentPayload = this.isAnyGiftCardSelected ? this.gcPaymentPayload : null;
      var creditCardInfo = this.creditCardInfo;
      var card = creditCardInfo.card;
      var cardNumberValidationInfo = creditCardInfo.numberValidationInfo;
      return {
        bin: (_card$cardNumber = card.cardNumber) === null || _card$cardNumber === void 0 ? void 0 : _card$cardNumber.substring(0, 6),
        token: null,
        provider: null,
        cardType: cardNumberValidationInfo === null || cardNumberValidationInfo === void 0 ? void 0 : (_cardNumberValidation = cardNumberValidationInfo.card) === null || _cardNumberValidation === void 0 ? void 0 : _cardNumberValidation.type,
        errorCode: null,
        CardHolderName: card === null || card === void 0 ? void 0 : card.nameOnCard,
        Zipcode: creditCardInfo.zipCode,
        Address1: creditCardInfo.addressLine1,
        Address2: creditCardInfo.addressLine2,
        Country: creditCardInfo.country,
        City: creditCardInfo.city,
        State: creditCardInfo.state,
        securityCode: null,
        CustomerID: sessionToken.customerID,
        CorrelationID: sessionToken.correlationID,
        errorDescription: null,
        ExpirationDate: creditCardInfo.expiry,
        ExpirationMonth: card.expMonth,
        ExpirationYear: card.expYear,
        action: "tokenizeCard",
        AJAX_FUNCTION: "tokenizeCard",
        paymentTokenType: this.creditCardInfo.saveCreditCard ? "LONGTERM" : "ONETIME",
        tipAmt: formCCPaymentPayload.creditCard.tipAmount + "",
        gcTipAmount: (gcPaymentPayload === null || gcPaymentPayload === void 0 ? void 0 : gcPaymentPayload.reduce(function (res, gcPayment) {
          var _gcPayment$giftCard;

          if (gcPayment !== null && gcPayment !== void 0 && (_gcPayment$giftCard = gcPayment.giftCard) !== null && _gcPayment$giftCard !== void 0 && _gcPayment$giftCard.tipAmount) {
            res = res + gcPayment.giftCard.tipAmount;
          }

          return res;
        }, 0.0)) + "",
        cardAmt: formCCPaymentPayload.creditCard.amount + "",
        isIncomplete: "false",
        // What should be passed here
        hasPartialPayment: this.isAnyGiftCardSelected ? "true" : "false",
        // What should be passed here
        orderID: orderId + "",
        paymentCode: null,
        // What should be passed here
        updateSavedCardMandate: this.creditCardInfo.saveCreditCard ? "true" : "false",
        // What should be passed here
        isSubsequent: "false",
        // What should be passed here
        ConceptName: DPServices.Config.getConceptCode(),
        ClientType: this.rootStore.isMobile ? "mobile-togo-tokenizecard" : "desktop-togo-tokenizecard",
        isDefaultCard: this.creditCardInfo.isDefault ? true : false,
        // What
        savecardtoProfile: this.creditCardInfo.saveCreditCard ? true : false,
        ResultCode: null,
        ResultMessage: null,
        TransType: "TOG",
        HostLocation: "ATG",
        redirectURL: "/commerce/order-confirmation",
        errorURL: "/commerce/checkout",
        origin_host: this.rootStore.platformUtil.getHostName(),
        origin_scheme: this.rootStore.platformUtil.getHostProtocol()
      };
    }
  }, {
    key: "getTokenizationFailureLogRequestRSA",
    value: function getTokenizationFailureLogRequestRSA(orderId) {
      var _card$cardNumber2, _cardNumberValidation2;

      var formCCPaymentPayload = this.formCCPaymentPayload;
      var creditCardInfo = this.creditCardInfo;
      var card = creditCardInfo.card;
      var cardNumberValidationInfo = creditCardInfo.numberValidationInfo;
      return {
        bin: (_card$cardNumber2 = card.cardNumber) === null || _card$cardNumber2 === void 0 ? void 0 : _card$cardNumber2.substring(0, 6),
        token: null,
        provider: null,
        cardType: cardNumberValidationInfo === null || cardNumberValidationInfo === void 0 ? void 0 : (_cardNumberValidation2 = cardNumberValidationInfo.card) === null || _cardNumberValidation2 === void 0 ? void 0 : _cardNumberValidation2.type,
        errorCode: null,
        CardHolderName: card === null || card === void 0 ? void 0 : card.nameOnCard,
        Zipcode: creditCardInfo.zipCode,
        Address1: creditCardInfo.addressLine1,
        Address2: creditCardInfo.addressLine2,
        Country: creditCardInfo.country,
        City: creditCardInfo.city,
        State: creditCardInfo.state,
        securityCode: null,
        CustomerID: null,
        CorrelationID: null,
        errorDescription: null,
        ExpirationDate: creditCardInfo.expiry,
        ExpirationMonth: card.expMonth,
        ExpirationYear: card.expYear,
        action: "tokenizeCard",
        AJAX_FUNCTION: "tokenizeCard",
        paymentTokenType: "TRANS_ARMOR",
        tipAmt: formCCPaymentPayload.creditCard.tipAmount + "",
        gcTipAmount: null,
        cardAmt: formCCPaymentPayload.creditCard.amount + "",
        isIncomplete: "false",
        // What should be passed here
        hasPartialPayment: this.isAnyGiftCardSelected ? "true" : "false",
        // What should be passed here
        orderID: orderId + "",
        paymentCode: null,
        // What should be passed here
        updateSavedCardMandate: this.creditCardInfo.saveCreditCard ? "true" : "false",
        // What should be passed here
        isSubsequent: "false",
        // What should be passed here
        ConceptName: DPServices.Config.getConceptCode(),
        ClientType: this.rootStore.isMobile ? "mobile-togo-tokenizecard" : "desktop-togo-tokenizecard",
        isDefaultCard: this.creditCardInfo.isDefault ? true : false,
        // What
        savecardtoProfile: this.creditCardInfo.saveCreditCard ? true : false,
        ResultCode: null,
        ResultMessage: null,
        TransType: "RSA",
        HostLocation: "ATG",
        redirectURL: "/commerce/order-confirmation",
        errorURL: "/commerce/checkout",
        origin_host: this.rootStore.platformUtil.getHostName(),
        origin_scheme: this.rootStore.platformUtil.getHostProtocol()
      };
    }
  }, {
    key: "resolveStateAndCountryFromZip",
    value: function () {
      var _resolveStateAndCountryFromZip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var zipCode, country, _yield$common$handle15, _yield$common$handle16, err, resp;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                zipCode = this.creditCardInfo.zipCode;
                country = this.creditCardInfo.country;

                if (!(zipCode && country)) {
                  _context10.next = 10;
                  break;
                }

                _context10.next = 5;
                return common.handle(DPServices.Common.getCityStateFromZip(zipCode, country));

              case 5:
                _yield$common$handle15 = _context10.sent;
                _yield$common$handle16 = _slicedToArray(_yield$common$handle15, 2);
                err = _yield$common$handle16[0];
                resp = _yield$common$handle16[1];

                if (!err) {
                  this.creditCardInfo.city = resp.city;
                  this.creditCardInfo.state = resp.state;
                }

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function resolveStateAndCountryFromZip() {
        return _resolveStateAndCountryFromZip.apply(this, arguments);
      }

      return resolveStateAndCountryFromZip;
    }()
  }, {
    key: "validateSecurityCode",
    value: function () {
      var _validateSecurityCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(paymentCorrelationId, orderId, sessionTokenSource, savedCreditCard, merchantId) {
        var _yield$common$handle17, _yield$common$handle18, orderRSATokenErr, orderRSATokenResponse, _err$response3, _err$response3$data, err, fault, orderRSAToken, rsaToken, encryptionFields, expiryDate, token, billingAddress, credit, type, account, referenceToken, payload, _yield$common$handle19, _yield$common$handle20, payTokenErr, paymentNonce, _ref3, _ref4, validateTokenErr, _err4$response, _err4$response$data, _err4, _fault;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return common.handle(DPServices.Payment.getRSAToken(utils.RSATokenTransactionType[sessionTokenSource], paymentCorrelationId, this.orderSessionRSARetryCount));

              case 2:
                _yield$common$handle17 = _context11.sent;
                _yield$common$handle18 = _slicedToArray(_yield$common$handle17, 2);
                orderRSATokenErr = _yield$common$handle18[0];
                orderRSATokenResponse = _yield$common$handle18[1];

                if (!orderRSATokenErr) {
                  _context11.next = 25;
                  break;
                }

                err = orderRSATokenErr; // all the retry attempts are already exhausted by RSAToken API

                this.orderSessionRSARetryCount = 0;

                if (!((_err$response3 = err.response) !== null && _err$response3 !== void 0 && (_err$response3$data = _err$response3.data) !== null && _err$response3$data !== void 0 && _err$response3$data.fault)) {
                  _context11.next = 20;
                  break;
                }

                fault = err.response.data.fault;

                if (!(fault.faultCode === "CHECK_NOT_LOADED")) {
                  _context11.next = 15;
                  break;
                }

                throw common.ERRORS.CHECK_NOT_LOADED;

              case 15:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 18:
                _context11.next = 23;
                break;

              case 20:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 23:
                _context11.next = 29;
                break;

              case 25:
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;
                this.isCCPaymentDisabled = false;
                this.rsaToken = orderRSAToken;

              case 29:
                rsaToken = this.rsaToken;

                if (!(rsaToken && rsaToken.publicKey && rsaToken.tokenId)) {
                  _context11.next = 101;
                  break;
                }

                encryptionFields = {
                  securityCode: savedCreditCard.creditCard.paymentCVV,
                  paymentCardToken: savedCreditCard.creditCard.paymentCardToken,
                  expirationMonth: savedCreditCard.creditCard.expirationMonth,
                  expirationYear: savedCreditCard.creditCard.expirationYear
                };
                _context11.next = 34;
                return common.handle(encryptAccount(encryptionFields, rsaToken));

              case 34:
                // Assemble Payload for PaymentNonceRequestRSA
                expiryDate = {
                  year: encryptionFields.expirationYear,
                  month: encryptionFields.expirationMonth
                };
                token = {
                  tokenProvider: "TRANS_ARMOR",
                  tokenId: encryptionFields.paymentCardToken
                }; // Full AVS validation for saved card

                billingAddress = {
                  postalCode: savedCreditCard.creditCard.billingAddress.postalCode,
                  locality: savedCreditCard.creditCard.billingAddress.city,
                  region: savedCreditCard.creditCard.billingAddress.state,
                  country: savedCreditCard.creditCard.billingAddress.country,
                  streetAddress: savedCreditCard.creditCard.billingAddress.address1
                };
                credit = {
                  securityCode: encryptionFields.securityCode,
                  cardType: savedCreditCard.creditCard.creditCardType,
                  token: token,
                  expiryDate: expiryDate,
                  billingAddress: billingAddress
                };
                type = "CREDIT";
                account = {
                  type: type,
                  credit: credit
                };
                referenceToken = {
                  tokenType: "CLAIM_CHECK_NONCE"
                };
                payload = {
                  merchantId: merchantId,
                  account: account,
                  referenceToken: referenceToken
                };
                _context11.next = 44;
                return common.handle(DPServices.Payment.getPaymentNonceRSA(rsaToken, payload));

              case 44:
                _yield$common$handle19 = _context11.sent;
                _yield$common$handle20 = _slicedToArray(_yield$common$handle19, 2);
                payTokenErr = _yield$common$handle20[0];
                paymentNonce = _yield$common$handle20[1];

                if (!(paymentNonce && paymentNonce.paymentNonce && !payTokenErr)) {
                  _context11.next = 97;
                  break;
                }

                if (!(sessionTokenSource === "MOBILE_PAY")) {
                  _context11.next = 55;
                  break;
                }

                _context11.next = 52;
                return common.handle(DPServices.Payment.validateToken("MobilePayValidateToken", paymentNonce.provider, "CLAIM_CHECK_NONCE", rsaToken.tokenId, savedCreditCard.creditCard.paymentCardToken, paymentNonce.paymentNonce));

              case 52:
                _context11.t0 = _context11.sent;
                _context11.next = 72;
                break;

              case 55:
                if (!(sessionTokenSource === "TOGO")) {
                  _context11.next = 61;
                  break;
                }

                _context11.next = 58;
                return common.handle(DPServices.Payment.validateToken("ToGoValidateToken", paymentNonce.provider, "CLAIM_CHECK_NONCE", rsaToken.tokenId, savedCreditCard.creditCard.paymentCardToken, paymentNonce.paymentNonce));

              case 58:
                _context11.t1 = _context11.sent;
                _context11.next = 71;
                break;

              case 61:
                if (!(sessionTokenSource === "PROFILE")) {
                  _context11.next = 67;
                  break;
                }

                _context11.next = 64;
                return common.handle(DPServices.Payment.validateToken("PROFILE", paymentNonce.provider, "CLAIM_CHECK_NONCE", rsaToken.tokenId, savedCreditCard.creditCard.paymentCardToken, paymentNonce.paymentNonce));

              case 64:
                _context11.t2 = _context11.sent;
                _context11.next = 70;
                break;

              case 67:
                _context11.next = 69;
                return common.handle(DPServices.Payment.validateToken("GiftcardValidateToken", paymentNonce.provider, "CLAIM_CHECK_NONCE", rsaToken.tokenId, savedCreditCard.creditCard.paymentCardToken, paymentNonce.paymentNonce));

              case 69:
                _context11.t2 = _context11.sent;

              case 70:
                _context11.t1 = _context11.t2;

              case 71:
                _context11.t0 = _context11.t1;

              case 72:
                _ref3 = _context11.t0;
                _ref4 = _slicedToArray(_ref3, 1);
                validateTokenErr = _ref4[0];

                if (!validateTokenErr) {
                  _context11.next = 94;
                  break;
                }

                this.orderSessionRSARetryCount = this.orderSessionRSARetryCount - 1;
                _err4 = validateTokenErr;

                if (!((_err4$response = _err4.response) !== null && _err4$response !== void 0 && (_err4$response$data = _err4$response.data) !== null && _err4$response$data !== void 0 && _err4$response$data.fault)) {
                  _context11.next = 89;
                  break;
                }

                _fault = _err4.response.data.fault;

                if (!(_fault.faultCode === "CHECK_NOT_LOADED")) {
                  _context11.next = 84;
                  break;
                }

                throw common.ERRORS.CHECK_NOT_LOADED;

              case 84:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 87:
                _context11.next = 92;
                break;

              case 89:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.CVV_VALIDATION_ERROR;

              case 92:
                _context11.next = 95;
                break;

              case 94:
                this.isCCPaymentDisabled = false;

              case 95:
                _context11.next = 99;
                break;

              case 97:
                // Only technical faults possbile for Nonce generation
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                throw common.ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE;

              case 99:
                _context11.next = 104;
                break;

              case 101:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 104:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function validateSecurityCode(_x13, _x14, _x15, _x16, _x17) {
        return _validateSecurityCode.apply(this, arguments);
      }

      return validateSecurityCode;
    }()
  }, {
    key: "tokenizePayPal",
    value: function () {
      var _tokenizePayPal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload, deviceData) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return DPServices.Payment.tokenizePayPal(payload.details.payerId, payload.nonce, deviceData.correlation_id);

              case 2:
                resp = _context12.sent;
                this.payPalData = {
                  tokenData: resp,
                  approvalData: payload,
                  deviceData: deviceData
                };

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function tokenizePayPal(_x18, _x19) {
        return _tokenizePayPal.apply(this, arguments);
      }

      return tokenizePayPal;
    }()
  }, {
    key: "tokenizePayPalRSA",
    value: function () {
      var _tokenizePayPalRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(paymentCorrelationId, payload, deviceData, merchantId, transactionType) {
        var _yield$common$handle21, _yield$common$handle22, orderRSATokenErr, orderRSATokenResponse, _err$response4, _err$response4$data, err, fault, orderRSAToken, payPalRSA, payPalAccountRSA, tokenPayPal, payloadRSA, resp;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return common.handle(DPServices.Payment.getRSAToken(transactionType, paymentCorrelationId, this.orderSessionRSARetryCount));

              case 2:
                _yield$common$handle21 = _context13.sent;
                _yield$common$handle22 = _slicedToArray(_yield$common$handle21, 2);
                orderRSATokenErr = _yield$common$handle22[0];
                orderRSATokenResponse = _yield$common$handle22[1];

                if (!orderRSATokenErr) {
                  _context13.next = 25;
                  break;
                }

                err = orderRSATokenErr; // all the retry attempts are already exhausted by RSAToken API

                this.orderSessionRSARetryCount = 0;

                if (!((_err$response4 = err.response) !== null && _err$response4 !== void 0 && (_err$response4$data = _err$response4.data) !== null && _err$response4$data !== void 0 && _err$response4$data.fault)) {
                  _context13.next = 20;
                  break;
                }

                fault = err.response.data.fault;

                if (!(fault.faultCode === "CHECK_NOT_LOADED")) {
                  _context13.next = 15;
                  break;
                }

                throw common.ERRORS.CHECK_NOT_LOADED;

              case 15:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 18:
                _context13.next = 23;
                break;

              case 20:
                this.isCCPaymentDisabled = this.isOrderSessionRSARetryCountExhausted;
                this.creditCardInfo.paymentToken = null;
                throw common.ERRORS.ORDER_SESSION_TOKEN_FAILURE;

              case 23:
                _context13.next = 28;
                break;

              case 25:
                orderRSAToken = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.rsaData;
                this.orderSessionRSARetryCount = orderRSATokenResponse === null || orderRSATokenResponse === void 0 ? void 0 : orderRSATokenResponse.retryRemaining;
                this.rsaToken = orderRSAToken;

              case 28:
                payPalRSA = {
                  payerId: payload.details.payerId,
                  nonce: payload.nonce
                };
                payPalAccountRSA = {
                  type: "PAYPAL",
                  paypal: payPalRSA
                };
                tokenPayPal = {
                  tokenProvider: "TRANS_ARMOR",
                  tokenType: "FORMAT_PRESERVING_MULTI_USE"
                };
                payloadRSA = {
                  merchantId: merchantId,
                  account: payPalAccountRSA,
                  token: tokenPayPal
                };
                resp = DPServices.Payment.getPayPalTokenRSA(this.rsaToken, payloadRSA);
                _context13.next = 35;
                return resp;

              case 35:
                _context13.t0 = _context13.sent;
                _context13.t1 = payload;
                _context13.t2 = deviceData;
                this.payPalData = {
                  tokenData: _context13.t0,
                  approvalData: _context13.t1,
                  deviceData: _context13.t2
                };

              case 39:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function tokenizePayPalRSA(_x20, _x21, _x22, _x23, _x24) {
        return _tokenizePayPalRSA.apply(this, arguments);
      }

      return tokenizePayPalRSA;
    }()
  }, {
    key: "prepareEditCreditCardValidationPayload",
    value: function prepareEditCreditCardValidationPayload() {
      var creditCardInfoModel = this.creditCardInfo;
      var expiry = creditCardInfoModel.expiry,
          firstName = creditCardInfoModel.firstName,
          lastName = creditCardInfoModel.lastName,
          firstAndLastName = creditCardInfoModel.firstAndLastName,
          billingAddress = creditCardInfoModel.billingAddress,
          savedCardPaymentToken = creditCardInfoModel.savedCardPaymentToken,
          savedCardType = creditCardInfoModel.savedCardType,
          cvv = creditCardInfoModel.cvv;
      var expiryParts = expiry.split("/");
      var expirationMonth = expiryParts[0];
      var expirationYear = expiryParts[1];
      var creditCard = {
        authAmount: 0,
        amount: 0,
        tipAmount: 0,
        paymentCardToken: savedCardPaymentToken,
        creditCardType: savedCardType,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cardAlias: savedCardPaymentToken.slice(-4),
        nickName: firstAndLastName,
        isVaulted: true,
        billingAddress: _objectSpread({
          firstName: firstName,
          lastName: lastName
        }, billingAddress),
        paymentCVV: cvv,
        acceptClientType: this.rootStore.acceptClientType
      };
      return {
        vaultedCard: true,
        cardOnFile: true,
        creditCard: creditCard
      };
    }
  }, {
    key: "prepareSaveEditCreditCardPayload",
    value: function () {
      var _prepareSaveEditCreditCardPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(actionOnCard) {
        var _yield$common$handle23, _yield$common$handle24, sessionAttributes, merchantId, paymentCorrelationId, _payload, errorDescription, creditCardInfoModel, addressLine1, addressLine2, city, state, country, zipCode, firstName, lastName, firstAndLastName, expiry, isDefault, paymentToken, savedCardPaymentToken, savedCardType, saveCreditCard, creditCardType, paymentCardToken, expiryParts, expirationMonth, expirationYear, _this$userProfile, login, userId, payload;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return common.handle(DPServices.Common.getSessionAttributes());

              case 2:
                _yield$common$handle23 = _context14.sent;
                _yield$common$handle24 = _slicedToArray(_yield$common$handle23, 2);
                sessionAttributes = _yield$common$handle24[1];
                merchantId = this.creditCardInfo.fullAVSEnabled ? sessionAttributes.fullAVSmerchantID : sessionAttributes.partialAVSmerchantID;
                paymentCorrelationId = sessionAttributes.paymentCorrelationId;
                _context14.prev = 7;

                if (!(actionOnCard === "Save")) {
                  _context14.next = 13;
                  break;
                }

                _context14.next = 11;
                return this.tokenizeCreditCardPaymentRSA(paymentCorrelationId, "", merchantId, "PROFILE");

              case 11:
                _context14.next = 16;
                break;

              case 13:
                _payload = this.prepareEditCreditCardValidationPayload();
                _context14.next = 16;
                return this.validateSecurityCode(paymentCorrelationId, "", "PROFILE", _payload, merchantId);

              case 16:
                _context14.next = 23;
                break;

              case 18:
                _context14.prev = 18;
                _context14.t0 = _context14["catch"](7);
                errorDescription = DPServices.Common.checkAndGetErrorDescription(_context14.t0) || Errors.SAVE_CREDIT_CARD_TO_PROFILE_FAILED;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw errorDescription;

              case 23:
                creditCardInfoModel = this.creditCardInfo;
                addressLine1 = creditCardInfoModel.addressLine1, addressLine2 = creditCardInfoModel.addressLine2, city = creditCardInfoModel.city, state = creditCardInfoModel.state, country = creditCardInfoModel.country, zipCode = creditCardInfoModel.zipCode, firstName = creditCardInfoModel.firstName, lastName = creditCardInfoModel.lastName, firstAndLastName = creditCardInfoModel.firstAndLastName, expiry = creditCardInfoModel.expiry, isDefault = creditCardInfoModel.isDefault, paymentToken = creditCardInfoModel.paymentToken, savedCardPaymentToken = creditCardInfoModel.savedCardPaymentToken, savedCardType = creditCardInfoModel.savedCardType, saveCreditCard = creditCardInfoModel.saveCreditCard;
                creditCardType = actionOnCard === "Save" ? paymentToken.cardType : savedCardType;
                paymentCardToken = actionOnCard === "Save" ? paymentToken.paymentToken : savedCardPaymentToken;
                expiryParts = expiry.split("/");
                expirationMonth = expiryParts[0];
                expirationYear = expiryParts[1];
                _this$userProfile = this.userProfile, login = _this$userProfile.login, userId = _this$userProfile.userId;
                payload = {
                  billingAddress: {
                    address1: addressLine1,
                    address2: addressLine2,
                    city: city,
                    country: country,
                    postalCode: zipCode,
                    state: state
                  },
                  firstName: firstName,
                  isAccepted: saveCreditCard,
                  isDefault: isDefault,
                  lastName: lastName,
                  nameOnCard: firstAndLastName,
                  creditCardBasicData: {
                    email: login,
                    creditCardType: creditCardType,
                    expirationMonth: expirationMonth,
                    expirationYear: expirationYear,
                    paymentCardToken: paymentCardToken,
                    userId: userId
                  }
                };
                return _context14.abrupt("return", payload);

              case 33:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[7, 18]]);
      }));

      function prepareSaveEditCreditCardPayload(_x25) {
        return _prepareSaveEditCreditCardPayload.apply(this, arguments);
      }

      return prepareSaveEditCreditCardPayload;
    }()
  }, {
    key: "saveCreditCardToProfile",
    value: function () {
      var _saveCreditCardToProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var payload, _yield$common$handle25, _yield$common$handle26, error, updatedUserProfile, errorDescription;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.prepareSaveEditCreditCardPayload("Save");

              case 2:
                payload = _context15.sent;
                _context15.next = 5;
                return common.handle(DPServices.User.saveCreditCardToUserProfile(payload));

              case 5:
                _yield$common$handle25 = _context15.sent;
                _yield$common$handle26 = _slicedToArray(_yield$common$handle25, 2);
                error = _yield$common$handle26[0];
                updatedUserProfile = _yield$common$handle26[1];

                if (!error) {
                  _context15.next = 15;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.SAVE_CREDIT_CARD_TO_PROFILE_FAILED;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw error;

              case 15:
                this.creditCardInfo.resetCreditCardModel();
                this.userProfile = updatedUserProfile;

              case 17:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function saveCreditCardToProfile() {
        return _saveCreditCardToProfile.apply(this, arguments);
      }

      return saveCreditCardToProfile;
    }()
  }, {
    key: "updateCreditCardAndSaveToUserProfile",
    value: function () {
      var _updateCreditCardAndSaveToUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var payload, _yield$common$handle27, _yield$common$handle28, error, updatedUserProfile, errorDescription;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.prepareSaveEditCreditCardPayload("Edit");

              case 2:
                payload = _context16.sent;
                _context16.next = 5;
                return common.handle(DPServices.User.updateCreditCardAndSaveToUserProfile(payload));

              case 5:
                _yield$common$handle27 = _context16.sent;
                _yield$common$handle28 = _slicedToArray(_yield$common$handle27, 2);
                error = _yield$common$handle28[0];
                updatedUserProfile = _yield$common$handle28[1];

                if (!error) {
                  _context16.next = 15;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.UPDATE_CREDIT_CARD_AND_SAVE_TO_PROFILE_FAILED;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw error;

              case 15:
                this.creditCardInfo.resetCreditCardModel();
                this.userProfile = updatedUserProfile;

              case 17:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateCreditCardAndSaveToUserProfile() {
        return _updateCreditCardAndSaveToUserProfile.apply(this, arguments);
      }

      return updateCreditCardAndSaveToUserProfile;
    }()
  }, {
    key: "deleteCreditCardFromUserProfile",
    value: function () {
      var _deleteCreditCardFromUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(cardDetails) {
        var _this$userProfile2, login, userId, selectedCard, creditCardType, _yield$common$handle29, _yield$common$handle30, error, updatedUserProfile, errorDescription;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this$userProfile2 = this.userProfile, login = _this$userProfile2.login, userId = _this$userProfile2.userId;
                selectedCard = this.userProfile.cardsList[cardDetails.cardIndex];
                creditCardType = selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.creditCardType;
                _context17.next = 5;
                return common.handle(DPServices.User.deleteCreditCardFromUserProfile({
                  email: login,
                  creditCardType: creditCardType,
                  paymentCardToken: selectedCard.paymentCardToken,
                  userId: userId,
                  expirationMonth: "",
                  expirationYear: ""
                }));

              case 5:
                _yield$common$handle29 = _context17.sent;
                _yield$common$handle30 = _slicedToArray(_yield$common$handle29, 2);
                error = _yield$common$handle30[0];
                updatedUserProfile = _yield$common$handle30[1];

                if (!error) {
                  _context17.next = 15;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.DELETE_CREDIT_CARD_FROM_USER_PROFILE;
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, errorDescription.message);
                throw error;

              case 15:
                this.creditCardInfo.resetCreditCardModel();
                this.userProfile = updatedUserProfile;

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function deleteCreditCardFromUserProfile(_x26) {
        return _deleteCreditCardFromUserProfile.apply(this, arguments);
      }

      return deleteCreditCardFromUserProfile;
    }()
  }, {
    key: "deleteGiftCard",
    value: function () {
      var _deleteGiftCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _this$userProfile3, userID, cardNo, maskedCardNo, _yield$common$handle31, _yield$common$handle32, err, resp, _DPServices$Cart$pars4, errObj, faults, haveErrorDescription, giftCardID, updatedCards;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                userID = (_this$userProfile3 = this.userProfile) === null || _this$userProfile3 === void 0 ? void 0 : _this$userProfile3.userId;
                cardNo = this.giftCardInfo.giftCardToDelete.cardNo;
                maskedCardNo = cardNo.substring(cardNo.length - 4, cardNo.length);
                _context18.next = 6;
                return common.handle(DPServices.Payment.deleteGiftCard(userID, this.giftCardInfo.giftCardToDelete.id, maskedCardNo));

              case 6:
                _yield$common$handle31 = _context18.sent;
                _yield$common$handle32 = _slicedToArray(_yield$common$handle31, 2);
                err = _yield$common$handle32[0];
                resp = _yield$common$handle32[1];

                if (!err) {
                  _context18.next = 19;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars4 = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars4 === void 0 ? void 0 : _DPServices$Cart$pars4.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context18.next = 18;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 18:
                throw Errors.DELETE_GIFT_CARD;

              case 19:
                this.giftCardInfo.isGiftCardSuccessfullyDeleted = true;
                giftCardID = this.giftCardInfo.giftCardToDelete.id;
                updatedCards = this._giftCards.filter(function (gc) {
                  return "" + gc.card.giftCardInfoId !== giftCardID;
                });
                this.giftCards = updatedCards;
                this.appMessages.showSuccess("Gift Card deleted", "The gift card ending ".concat(maskedCardNo, " is successfully removed from your profile"));
                _context18.next = 30;
                break;

              case 26:
                _context18.prev = 26;
                _context18.t0 = _context18["catch"](0);
                this.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context18.t0.message);
                this.giftCardInfo.isGiftCardSuccessfullyDeleted = false;

              case 30:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 26]]);
      }));

      function deleteGiftCard() {
        return _deleteGiftCard.apply(this, arguments);
      }

      return deleteGiftCard;
    }()
  }, {
    key: "updateCityStateCountryFromZip",
    value: function updateCityStateCountryFromZip() {
      var creditCardInfoModel = this.creditCardInfo;

      if (creditCardInfoModel.checkIfZipValid && creditCardInfoModel.fullAVSEnabled) {
        this.resolveStateAndCountryFromZip();
      } else {
        var validCountries = common.COUNTRIES.filter(function (item) {
          return common.isZipValid(creditCardInfoModel === null || creditCardInfoModel === void 0 ? void 0 : creditCardInfoModel.zipCode, item.code);
        });

        if (validCountries.length) {
          creditCardInfoModel.country = validCountries[0].code;

          if (creditCardInfoModel.fullAVSEnabled) {
            this.resolveStateAndCountryFromZip();
          }
        }
      }
    }
  }, {
    key: "setShowError",
    value: function setShowError(val) {
      this._showError = val;
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(price) {
      var _BrandRules, _this$_appAttributes;

      var pricingFormat = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat();

      switch (pricingFormat) {
        case "$xx":
          return "$".concat(price.toFixed(0));

        case "$xx.xx":
          return "$".concat(price.toFixed(2));

        case "xx":
          return "".concat(price.toFixed(0));

        case "xx.xx":
          return "".concat(price.toFixed(2));

        case "s52":
          return "".concat(Number(price.toFixed(2)));

        default:
          return "$".concat(price.toFixed(2));
      }
    }
  }, {
    key: "showFormattedPrice",
    value: function showFormattedPrice(num) {
      var finalResult;

      if (num === undefined || num === null || num === "") {
        return "";
      } else if (typeof num === "string") {
        if (num.length <= 0) return "";
        var res = num.replace(/[^\d.]/g, "");
        var b = num.replace(/[\d.]/g, "").replace("$", "");
        finalResult = b + this.formatPrice(Number(res));
      } else {
        finalResult = this.formatPrice(num);
      }

      return finalResult.toString();
    }
  }, {
    key: "activePaymentTab",
    get: function get() {
      return this._activePaymentTab;
    },
    set: function set(_activePaymentTab) {
      var _this10 = this;

      runInAction(function () {
        _this10._activePaymentTab = _activePaymentTab;
      });
    }
  }, {
    key: "flow",
    get: function get() {
      return this._flow;
    },
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._flow = val;
      });
    }
  }, {
    key: "paymentCVVEnabled",
    get: function get() {
      return this._paymentCVVEnabled;
    },
    set: function set(paymentCVVEnabled) {
      var _this12 = this;

      runInAction(function () {
        _this12._paymentCVVEnabled = paymentCVVEnabled;
      });
    }
  }, {
    key: "requestPhoneNumberFromAppleOrGooglePay",
    get: function get() {
      return this._requestPhoneNumberFromAppleOrGooglePay;
    },
    set: function set(requestPhoneNumberFromAppleOrGooglePay) {
      var _this13 = this;

      runInAction(function () {
        _this13._requestPhoneNumberFromAppleOrGooglePay = requestPhoneNumberFromAppleOrGooglePay;
      });
    }
  }, {
    key: "requestShippingFieldsFromAppleOrGooglePay",
    get: function get() {
      return this._requestShippingFieldsFromAppleOrGooglePay;
    },
    set: function set(requestShippingFieldsFromAppleOrGooglePay) {
      var _this14 = this;

      runInAction(function () {
        _this14._requestShippingFieldsFromAppleOrGooglePay = requestShippingFieldsFromAppleOrGooglePay;
      });
    }
  }, {
    key: "formSubmitted",
    get: function get() {
      return this._formSubmitted;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._formSubmitted = val;
      });
    }
  }, {
    key: "activeOtherOptionTab",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT || this.isSavedCreditCardSelected) {
        return utils.OnlinePaymentTypes.NONE;
      }

      return this.toPay > 0 ? this._activeOtherOptionTab : utils.OnlinePaymentTypes.NONE;
    },
    set: function set(activeOtherOptionTab) {
      var _this16 = this;

      runInAction(function () {
        _this16._activeOtherOptionTab = activeOtherOptionTab;
      });

      if (activeOtherOptionTab !== utils.OnlinePaymentTypes.NONE) {
        this.deSelectCreditCards();
      }
    }
  }, {
    key: "paymentCVV",
    get: function get() {
      return this._paymentCVV;
    },
    set: function set(val) {
      var _this17 = this;

      runInAction(function () {
        _this17._paymentCVV = val;
      });
    }
  }, {
    key: "smartPayOptionsEnabled",
    get: function get() {
      return this.isPayPalEnabled || this.isGooglePayEnabled || this.isApplePayEnabled;
    }
  }, {
    key: "allowedPaymentMethods",
    get: function get() {
      return this._allowedPaymentMethods;
    },
    set: function set(val) {
      var _this18 = this;

      runInAction(function () {
        _this18._allowedPaymentMethods = val;

        if (val === "PAY_REST") {
          _this18._activePaymentTab = utils.PaymentMethods.PAY_AT_RESTAURANT;
        } else {
          _this18._activePaymentTab = utils.PaymentMethods.ONLINE;
        }
      });
    }
  }, {
    key: "onlinePaymentsOrder",
    get: function get() {
      var paymentTypes = [utils.OnlinePaymentTypes.CREDIT_CARD];

      if (this.isPayPalEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.PAYPAL);
      }

      if (this.isApplePayEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.APPLE_PAY);
      }

      if (this.isGooglePayEnabled) {
        paymentTypes.push(utils.OnlinePaymentTypes.GOOGLE_PAY);
      }

      return paymentTypes;
    }
  }, {
    key: "isCCPaymentDisabled",
    get: function get() {
      return this._isCCPaymentDisabled;
    },
    set: function set(isCCPaymentDisabled) {
      var _this19 = this;

      runInAction(function () {
        _this19._isCCPaymentDisabled = isCCPaymentDisabled;
      });
    }
  }, {
    key: "orderPriceInfo",
    get: function get() {
      return this._orderPriceInfo;
    },
    set: function set(val) {
      var _this20 = this;

      runInAction(function () {
        _this20._orderPriceInfo = val;
      });
    }
  }, {
    key: "tippableAmount",
    get: function get() {
      return this._tippableAmount;
    },
    set: function set(val) {
      var _this21 = this;

      runInAction(function () {
        _this21._tippableAmount = val;

        if (val <= 0) {
          _this21.gratuityModel.addGratuity = false;
          _this21.gratuityModel.selectedTipPercentage = 0;
        }
      });
    }
  }, {
    key: "subTotalWithoutItemDiscount",
    get: function get() {
      return this._subTotalWithoutItemDiscount;
    },
    set: function set(val) {
      var _this22 = this;

      runInAction(function () {
        _this22._subTotalWithoutItemDiscount = val;
      });
    }
  }, {
    key: "sessionToken",
    get: function get() {
      return this._sessionToken;
    },
    set: function set(val) {
      var _this23 = this;

      runInAction(function () {
        _this23._sessionToken = val;
      });
    }
  }, {
    key: "rsaToken",
    get: function get() {
      return this._rsaToken;
    },
    set: function set(val) {
      var _this24 = this;

      runInAction(function () {
        _this24._rsaToken = val;
      });
    }
  }, {
    key: "validateToken",
    get: function get() {
      return this._validateToken;
    },
    set: function set(val) {
      var _this25 = this;

      runInAction(function () {
        _this25._validateToken = val;
      });
    }
  }, {
    key: "encryptionFields",
    get: function get() {
      return this._encryptionFields;
    },
    set: function set(val) {
      var _this26 = this;

      runInAction(function () {
        _this26._encryptionFields = val;
      });
    }
  }, {
    key: "payPalData",
    get: function get() {
      return this._payPalData;
    },
    set: function set(val) {
      var _this27 = this;

      runInAction(function () {
        _this27._payPalData = val;
      });
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this28 = this;

      runInAction(function () {
        _this28._componentRef = _componentRef;
      });
    }
  }, {
    key: "savedGiftCardsLimit",
    get: function get() {
      return this._savedGiftCardsLimit;
    },
    set: function set(savedGiftCardsLimit) {
      var _this29 = this;

      runInAction(function () {
        _this29._savedGiftCardsLimit = savedGiftCardsLimit;
      });
    }
  }, {
    key: "maximumGCAllowedPerOrder",
    get: function get() {
      var _this$rootStore3, _this$rootStore3$comm, _this$rootStore3$comm2;

      var appConfig = (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$comm = _this$rootStore3.common) === null || _this$rootStore3$comm === void 0 ? void 0 : (_this$rootStore3$comm2 = _this$rootStore3$comm.appAttributes) === null || _this$rootStore3$comm2 === void 0 ? void 0 : _this$rootStore3$comm2.configs;

      if (this.flow === utils.PaymentFlow.MPAY_CLQ || this.flow === utils.PaymentFlow.MPAY_TLQ) {
        return parseInt(appConfig !== null && appConfig !== void 0 && appConfig.maximumGCAllowedPerCheck ? appConfig.maximumGCAllowedPerCheck : "1");
      } else return parseInt(appConfig !== null && appConfig !== void 0 && appConfig.maximumGCAllowedPerOrder ? appConfig.maximumGCAllowedPerOrder : "3");
    },
    set: function set(maximumGCAllowedPerOrder) {
      var _this30 = this;

      runInAction(function () {
        _this30._maximumGCAllowedPerOrder = maximumGCAllowedPerOrder;
      });
    }
  }, {
    key: "rsaFlowEnabled",
    get: function get() {
      return this._rsaFlowEnabled;
    },
    set: function set(rsaFlowEnabled) {
      var _this31 = this;

      runInAction(function () {
        _this31._rsaFlowEnabled = rsaFlowEnabled;
      });
    }
  }, {
    key: "gratuity",
    get: function get() {
      if (this.isPayAtRest) return 0;
      var selectedTipPercentage = this.gratuityModel.selectedTipPercentage;
      var tipAmount = this.gratuityModel.tipAmount;
      var showCustomAmount = this.gratuityModel.showCustomAmount;
      var gratuityAmount = showCustomAmount ? tipAmount : this.tippableAmount * selectedTipPercentage * 0.01;
      return gratuityAmount ? common.roundTo(gratuityAmount, 2) : 0.0;
    }
  }, {
    key: "userProfile",
    get: function get() {
      return this._userProfile;
    },
    set: function set(profile) {
      var _this32 = this;

      runInAction(function () {
        _this32._userProfile = profile;

        _this32.setGiftCards(profile === null || profile === void 0 ? void 0 : profile.giftCards);

        _this32.setCreditCards(profile === null || profile === void 0 ? void 0 : profile.cardsList);

        var defaultCreditCardPaymentToken = profile.defaultCreditCardPaymentToken;

        if (defaultCreditCardPaymentToken) {
          var _profile$cardsList;

          var defaultSavedCards = profile === null || profile === void 0 ? void 0 : (_profile$cardsList = profile.cardsList) === null || _profile$cardsList === void 0 ? void 0 : _profile$cardsList.filter(function (card) {
            return card.paymentCardToken === defaultCreditCardPaymentToken;
          });
          var defaultSavedCard = defaultSavedCards ? defaultSavedCards[0] : null;

          if (defaultSavedCard) {
            _this32.selectCreditCard({
              card: defaultSavedCard,
              isSelected: true,
              isDisabled: false,
              isVisible: true,
              proratedTip: 0,
              proratedAmount: 0,
              paymentCVV: null,
              hasExpired: false,
              isDefault: true
            });
          }
        }
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT) {
        return true;
      }

      if (this.isSavedCreditCardSelected) {
        if (this.paymentCVVEnabled) {
          var _this$selectedCreditC;

          var creditCardInfo = common.getCardTypeInfo(this.selectedCreditCard.card.creditCardType);
          return !!((_this$selectedCreditC = this.selectedCreditCard) !== null && _this$selectedCreditC !== void 0 && _this$selectedCreditC.paymentCVV) && this.selectedCreditCard.paymentCVV.length === creditCardInfo.code.size;
        } else {
          return true;
        }
      } else if (this.isSelectedGiftCardsSufficient) {
        return true;
      } else if (this.creditCardInfo.isValid) {
        return true;
      } else if (this.activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this.activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY || this.activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY) {
        return true;
      }

      return false;
    }
  }, {
    key: "giftCards",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT) {
        var _this$_giftCards;

        return (_this$_giftCards = this._giftCards) === null || _this$_giftCards === void 0 ? void 0 : _this$_giftCards.map(function (giftCard) {
          return _objectSpread(_objectSpread({}, giftCard), {}, {
            isSelected: false
          });
        });
      }

      return this._giftCards;
    },
    set: function set(_giftCards) {
      var _this33 = this;

      runInAction(function () {
        _this33._giftCards = _giftCards;
      });
    }
  }, {
    key: "giftCardRecaptchaSiteKey",
    get: function get() {
      return this._giftCardRecaptchaSiteKey;
    }
  }, {
    key: "canAddGiftCard",
    get: function get() {
      return this._giftCards && this._giftCards.length < this.savedGiftCardsLimit;
    }
  }, {
    key: "creditCards",
    get: function get() {
      if (this.activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT || this.isOnlinePaySelected || this.isSelectedGiftCardsSufficient) {
        var _this$_creditCards;

        return (_this$_creditCards = this._creditCards) === null || _this$_creditCards === void 0 ? void 0 : _this$_creditCards.map(function (creditCard, i) {
          return _objectSpread(_objectSpread({}, creditCard), {}, {
            isSelected: false
          });
        });
      }

      return this._creditCards;
    }
  }, {
    key: "isSavedCreditCardSelected",
    get: function get() {
      return !!this.selectedCreditCard;
    }
  }, {
    key: "selectedCreditCard",
    get: function get() {
      var _this$creditCards;

      var selectedCards = (_this$creditCards = this.creditCards) === null || _this$creditCards === void 0 ? void 0 : _this$creditCards.filter(function (card) {
        return card.isSelected;
      });
      return selectedCards && selectedCards.length ? selectedCards[0] : null;
    }
  }, {
    key: "selectedCreditCardCVV",
    set: function set(val) {
      var _this34 = this;

      runInAction(function () {
        _this34.selectedCreditCard.paymentCVV = val;
      });
    }
  }, {
    key: "isSelectedGiftCardsSufficient",
    get: function get() {
      return this.selectedGCRemainingBal >= 0;
    }
  }, {
    key: "selectedGCRemainingBal",
    get: function get() {
      var selectedCards = this.giftCards.filter(function (item) {
        return item.isSelected;
      });
      var totalGCAmount = 0;
      selectedCards.forEach(function (card) {
        return totalGCAmount += card.card.giftCardBalance;
      });
      return totalGCAmount - this.orderTotalIncludingGratuity;
    }
  }, {
    key: "isAnyGiftCardSelected",
    get: function get() {
      return this.giftCards.filter(function (item) {
        return item.isSelected;
      }).length > 0;
    }
  }, {
    key: "isMaxGCLimit",
    get: function get() {
      var _this$appliedGiftCard;

      return ((_this$appliedGiftCard = this.appliedGiftCards) === null || _this$appliedGiftCard === void 0 ? void 0 : _this$appliedGiftCard.length) >= this.maximumGCAllowedPerOrder;
    }
  }, {
    key: "isGCFailureLimitReached",
    get: function get() {
      return this._isGCFailureLimitReached;
    },
    set: function set(val) {
      var _this35 = this;

      runInAction(function () {
        _this35._isGCFailureLimitReached = val;
      });
    }
  }, {
    key: "appliedGiftCards",
    get: function get() {
      var _this36 = this;

      var appliedGiftCards = [];
      var remainingBalance = this.orderTotalIncludingGratuity;
      var tipPercent = this.gratuity / this.orderTotalIncludingGratuity;
      var sortedCards = this.giftCards.slice().sort(function (a, b) {
        return a.selectionOrder - b.selectionOrder;
      });
      sortedCards.forEach(function (card) {
        if (card.isSelected) {
          var clonnedCard = _objectSpread({}, card);

          if (clonnedCard.card.giftCardBalance >= remainingBalance) {
            clonnedCard.amountUsed = remainingBalance;
            remainingBalance = 0;
          } else {
            clonnedCard.amountUsed = clonnedCard.card.giftCardBalance;
            remainingBalance = remainingBalance - clonnedCard.amountUsed;
          } //prorated


          var _this36$getAuthAndTip = _this36.getAuthAndTipAmounts(clonnedCard.amountUsed, tipPercent),
              authAmount = _this36$getAuthAndTip.authAmount,
              tipAmount = _this36$getAuthAndTip.tipAmount;

          clonnedCard.proratedAmount = authAmount;
          clonnedCard.proratedTip = tipAmount;
          appliedGiftCards.push(clonnedCard);
        }
      });
      return appliedGiftCards;
    }
  }, {
    key: "totalGCPaidAmount",
    get: function get() {
      var selectedCards = this.appliedGiftCards;
      var totalGCAmt = 0;
      selectedCards.forEach(function (card) {
        totalGCAmt += card.amountUsed;
      });
      return totalGCAmt;
    }
  }, {
    key: "totalGCAuthAndTipAmounts",
    get: function get() {
      var selectedCards = this.appliedGiftCards;
      var totalAuthAmount = 0;
      var totalTipAmount = 0;
      selectedCards.forEach(function (card) {
        totalAuthAmount += card.proratedAmount;
        totalTipAmount += card.proratedTip;
      });
      return {
        authAmount: totalAuthAmount,
        tipAmount: totalTipAmount
      };
    }
  }, {
    key: "remainingAuthAndTipAmounts",
    get: function get() {
      var authAndTipAmounts = this.totalGCAuthAndTipAmounts;
      var totalGCAuthAmount = authAndTipAmounts.authAmount;
      var totalGCTipAmount = authAndTipAmounts.tipAmount;

      if (totalGCAuthAmount > this.remainingOrderTotal) {
        // over paid on GC possibly because of abnormal tip amount.
        var tipPortionOnGCAuthAmount = totalGCAuthAmount - this.remainingOrderTotal;
        var remainingTip = common.roundTo(this.gratuity - (tipPortionOnGCAuthAmount + totalGCTipAmount), 2) - 0.01;
        return {
          authAmount: 0.01,
          tipAmount: remainingTip
        };
      } else {
        return {
          authAmount: common.roundTo(this.remainingOrderTotal - totalGCAuthAmount, 2),
          tipAmount: common.roundTo(this.gratuity - totalGCTipAmount, 2)
        };
      }
    }
  }, {
    key: "toPay",
    get: function get() {
      return this.orderTotalIncludingGratuity - this.totalGCPaidAmount;
    }
  }, {
    key: "orderAmount",
    get: function get() {
      if (this.orderPriceInfo) {
        return this.orderPriceInfo.rawSubtotal - (this.orderPriceInfo.discountAmount || 0);
      } else {
        return 0;
      }
    }
  }, {
    key: "orderTotal",
    get: function get() {
      var _this$orderPriceInfo, _this$orderPriceInfo2, _this$orderPriceInfo3;

      return this.orderAmount + (((_this$orderPriceInfo = this.orderPriceInfo) === null || _this$orderPriceInfo === void 0 ? void 0 : _this$orderPriceInfo.tax) || 0.0) + (((_this$orderPriceInfo2 = this.orderPriceInfo) === null || _this$orderPriceInfo2 === void 0 ? void 0 : _this$orderPriceInfo2.shipping) || 0.0) + (((_this$orderPriceInfo3 = this.orderPriceInfo) === null || _this$orderPriceInfo3 === void 0 ? void 0 : _this$orderPriceInfo3.bagFee) || 0.0);
    }
  }, {
    key: "remainingOrderTotal",
    get: function get() {
      return this.orderTotal - this.amountPaid;
    }
  }, {
    key: "amountPaid",
    get: function get() {
      var _this$orderPriceInfo4;

      return ((_this$orderPriceInfo4 = this.orderPriceInfo) === null || _this$orderPriceInfo4 === void 0 ? void 0 : _this$orderPriceInfo4.amountAlreadyPaid) || 0.0;
    }
  }, {
    key: "orderTotalIncludingGratuity",
    get: function get() {
      return this.remainingOrderTotal + this.gratuity;
    }
  }, {
    key: "cardAlreadySaved",
    get: function get() {
      var _this37 = this;

      var filteredCards = this.giftCards.filter(function (gc) {
        return gc.isSavedCard && gc.card.giftCardNumber === _this37.giftCardInfo.rawGCNumber;
      });
      return !!filteredCards.length;
    }
  }, {
    key: "payPalPaymentPayload",
    get: function get() {
      var _this$remainingAuthAn = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn.authAmount,
          tipAmount = _this$remainingAuthAn.tipAmount;
      var tokenData = this.payPalData.tokenData;
      var approvalDetails = this.payPalData.approvalData.details;
      var payment = {
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: tokenData.paypalToken,
        expirationMonth: tokenData.expiryMonth,
        expirationYear: tokenData.expiryYear,
        cardAlias: tokenData.paypalToken.substring(tokenData.paypalToken.length - 4),
        authorizationId: this.payPalData.tokenData.fdAuthorizationId,
        firstName: approvalDetails.firstName,
        lastName: approvalDetails.lastName,
        email: approvalDetails.email,
        billingAddress: approvalDetails.billingAddress,
        phone: approvalDetails.phone
      };
      return {
        payPalPayment: payment
      };
    }
  }, {
    key: "paypalPaymentPayload",
    get: function get() {
      var _this$payPalData, _this$payPalData2, _this$payPalData3; //THIS IS FOR MOBILE PAY DO NOT CHANGE FOR CHECKOUT
      // Added tokenData for Pay Now - CALLIN/ETOGO payments


      var _this$remainingAuthAn2 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn2.authAmount,
          tipAmount = _this$remainingAuthAn2.tipAmount;
      var deviceData = this === null || this === void 0 ? void 0 : (_this$payPalData = this.payPalData) === null || _this$payPalData === void 0 ? void 0 : _this$payPalData.deviceData;
      var approval = this === null || this === void 0 ? void 0 : (_this$payPalData2 = this.payPalData) === null || _this$payPalData2 === void 0 ? void 0 : _this$payPalData2.approvalData;
      var approvalDetails = approval === null || approval === void 0 ? void 0 : approval.details;
      var billingAddress = approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.billingAddress;
      var payment = {
        billingInfo: {
          firstName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.firstName,
          lastName: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.lastName,
          email: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.email,
          phone: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.phone,
          line1: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.line1,
          line2: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.line2,
          city: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city,
          postalCode: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode,
          state: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.state,
          countryCode: billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode
        },
        transcationInfo: {
          nonce: approval === null || approval === void 0 ? void 0 : approval.nonce,
          type: approval === null || approval === void 0 ? void 0 : approval.type,
          correlationId: deviceData === null || deviceData === void 0 ? void 0 : deviceData.correlation_id,
          payerId: approvalDetails === null || approvalDetails === void 0 ? void 0 : approvalDetails.payerId
        },
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };

      if ((_this$payPalData3 = this.payPalData) !== null && _this$payPalData3 !== void 0 && _this$payPalData3.tokenData) {
        payment.tokenData = this.payPalData.tokenData;
      }

      return {
        paypalPayment: payment
      };
    }
  }, {
    key: "applePayPaymentPayload",
    get: function get() {
      var _this$remainingAuthAn3 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn3.authAmount,
          tipAmount = _this$remainingAuthAn3.tipAmount;
      var payment = {
        billingInfo: _objectSpread(_objectSpread({}, this.applePayAuthorization.shippingContact), this.applePayAuthorization.billingContact),
        transcationInfo: this.applePayAuthorization.token,
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };
      return {
        applePayPayment: payment
      };
    }
  }, {
    key: "googlePayPaymentPayload",
    get: function get() {
      var _this$remainingAuthAn4 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn4.authAmount,
          tipAmount = _this$remainingAuthAn4.tipAmount;
      var payment = {
        billingInfo: this.googlePayAuthorization.paymentMethodData.info,
        transcationInfo: this.googlePayAuthorization.paymentMethodData,
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        currencyCode: "USD"
      };
      return {
        googlePayPayment: payment
      };
    }
  }, {
    key: "googlePayIsReadyToPayRequest",
    get: function get() {
      return {
        apiVersion: this.googlePayPaymentRequest.apiVersion,
        apiVersionMinor: this.googlePayPaymentRequest.apiVersionMinor,
        allowedPaymentMethods: this.googlePayPaymentRequest.allowedPaymentMethods,
        existingPaymentMethodRequired: true
      };
    }
  }, {
    key: "googlePayPaymentRequest",
    get: function get() {
      var _ref5, _appAttributes$google, _ref6, _appAttributes$google2, _appAttributes$google3, _appAttributes$google4, _appAttributes$concep, _appAttributes$concep2, _this$subTotalWithout, _this$orderPriceInfo5;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config.paypalDisplayName;

      var paymentRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        emailRequired: true,
        allowedPaymentMethods: [{
          type: "CARD",
          parameters: {
            allowedAuthMethods: (_ref5 = (_appAttributes$google = appAttributes.googlePayConfig) === null || _appAttributes$google === void 0 ? void 0 : _appAttributes$google.allowedAuthMethods.map(function (authMethod) {
              return authMethod.trim();
            })) !== null && _ref5 !== void 0 ? _ref5 : ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            allowedCardNetworks: (_ref6 = (_appAttributes$google2 = appAttributes.googlePayConfig) === null || _appAttributes$google2 === void 0 ? void 0 : _appAttributes$google2.allowedCardNetworks.map(function (network) {
              return network.trim();
            })) !== null && _ref6 !== void 0 ? _ref6 : ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"],
            billingAddressRequired: true,
            billingAddressParameters: {
              format: "FULL",
              phoneNumberRequired: this.requestPhoneNumberFromAppleOrGooglePay ? true : false
            }
          },
          tokenizationSpecification: {
            type: "PAYMENT_GATEWAY",
            parameters: {
              gateway: (_appAttributes$google3 = (_appAttributes$google4 = appAttributes.googlePayConfig) === null || _appAttributes$google4 === void 0 ? void 0 : _appAttributes$google4.gateway) !== null && _appAttributes$google3 !== void 0 ? _appAttributes$google3 : "firstdata",
              gatewayMerchantId: this.googlePayGatewayMerchantId
            }
          }
        }],
        transactionInfo: {
          currencyCode: "USD",
          countryCode: "US",
          totalPriceStatus: "FINAL",
          totalPrice: this.toPay.toFixed(2),
          totalPriceLabel: this.isAnyGiftCardSelected || this.amountPaid ? "To Pay" : "Total",
          checkoutOption: "COMPLETE_IMMEDIATE_PURCHASE",
          displayItems: []
        },
        merchantInfo: {
          merchantId: this.googlePayPaymentMerchantId,
          merchantName: (_appAttributes$concep = (_appAttributes$concep2 = appAttributes.concept) === null || _appAttributes$concep2 === void 0 ? void 0 : _appAttributes$concep2.conceptCodeDesc) !== null && _appAttributes$concep !== void 0 ? _appAttributes$concep : paypalDisplayName
        },
        callbackIntents: ["PAYMENT_AUTHORIZATION"]
      };
      paymentRequest.transactionInfo.displayItems.push({
        label: "Subtotal",
        type: "SUBTOTAL",
        price: (_this$subTotalWithout = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout === void 0 ? void 0 : _this$subTotalWithout.toFixed(2),
        status: "FINAL"
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.transactionInfo.displayItems.push({
          label: "Coupon Discount",
          type: "DISCOUNT",
          price: discountAmountStr,
          status: "FINAL"
        });
      }

      if ((_this$orderPriceInfo5 = this.orderPriceInfo) !== null && _this$orderPriceInfo5 !== void 0 && _this$orderPriceInfo5.shipping) {
        paymentRequest.transactionInfo.displayItems.push({
          label: "Delivery",
          type: "SHIPPING_OPTION",
          price: this.orderPriceInfo.shipping.toFixed(2),
          status: "FINAL"
        });
      }

      paymentRequest.transactionInfo.displayItems.push({
        label: "Taxes",
        type: "TAX",
        price: this.orderPriceInfo ? this.orderPriceInfo.tax.toFixed(2) : "0.00",
        status: "FINAL"
      });
      paymentRequest.transactionInfo.displayItems.push({
        label: "Gratuity",
        type: "LINE_ITEM",
        price: this.gratuity ? this.gratuity.toFixed(2) : "0.00",
        status: "FINAL"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.transactionInfo.displayItems.push({
            label: "Gift Card Ending With " + last4,
            type: "DISCOUNT",
            price: "-" + amountUsed.toFixed(2),
            status: "FINAL"
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "applePayPaymentMerchantId",
    get: function get() {
      var _common$getEnvProps3 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps3.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps3.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "merchant.com.darden.sandbox.applepay";
      } else {
        var _appAttributes$appleP, _appAttributes$appleP2;

        return (_appAttributes$appleP = (_appAttributes$appleP2 = appAttributes.applePayConfig) === null || _appAttributes$appleP2 === void 0 ? void 0 : _appAttributes$appleP2.paymentMerchantId) !== null && _appAttributes$appleP !== void 0 ? _appAttributes$appleP : DEVELOPMENT ? "merchant.com.darden.sandbox.applepay" : "merchant.com.darden.applepay";
      }
    }
  }, {
    key: "googlePayPaymentMerchantId",
    get: function get() {
      var _common$getEnvProps4 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps4.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps4.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "BCR2DN6TSOQI33L7";
      } else {
        var _appAttributes$google5, _appAttributes$google6, _appAttributes$google7;

        return (_appAttributes$google5 = (_appAttributes$google6 = appAttributes.googlePayConfig) === null || _appAttributes$google6 === void 0 ? void 0 : _appAttributes$google6.paymentMerchantId) !== null && _appAttributes$google5 !== void 0 ? _appAttributes$google5 : DEVELOPMENT ? "BCR2DN6TSOQI33L7" : (_appAttributes$google7 = appAttributes.googlePayConfig) === null || _appAttributes$google7 === void 0 ? void 0 : _appAttributes$google7.paymentMerchantId;
      }
    }
  }, {
    key: "googlePayGatewayMerchantId",
    get: function get() {
      var _common$getEnvProps5 = common.getEnvProps(),
          NODE_ENV = _common$getEnvProps5.NODE_ENV,
          NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV = _common$getEnvProps5.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV;

      var DEVELOPMENT = NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV === "development";
      var DEV_NODE_ENV = NODE_ENV === "development";
      var appAttributes = this.rootStore.common.appAttributes;

      if (DEV_NODE_ENV) {
        return "3176752955";
      } else {
        var _appAttributes$google8, _appAttributes$google9;

        return (_appAttributes$google8 = (_appAttributes$google9 = appAttributes.googlePayConfig) === null || _appAttributes$google9 === void 0 ? void 0 : _appAttributes$google9.gatewayMerchantId) !== null && _appAttributes$google8 !== void 0 ? _appAttributes$google8 : DEVELOPMENT ? "3176752955" : "376246695997";
      }
    }
  }, {
    key: "applePayPaymentRequest",
    get: function get() {
      var _appAttributes$appleP3, _appAttributes$appleP4, _appAttributes$appleP5, _appAttributes$appleP6, _appAttributes$concep3, _appAttributes$concep4, _this$subTotalWithout2, _this$orderPriceInfo6;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config2 = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config2.paypalDisplayName;

      var paymentRequest = {
        countryCode: "US",
        currencyCode: "USD",
        merchantCapabilities: (_appAttributes$appleP3 = (_appAttributes$appleP4 = appAttributes.applePayConfig) === null || _appAttributes$appleP4 === void 0 ? void 0 : _appAttributes$appleP4.allowedAuthMethods) !== null && _appAttributes$appleP3 !== void 0 ? _appAttributes$appleP3 : ["supports3DS"],
        supportedNetworks: (_appAttributes$appleP5 = (_appAttributes$appleP6 = appAttributes.applePayConfig) === null || _appAttributes$appleP6 === void 0 ? void 0 : _appAttributes$appleP6.allowedCardNetworks) !== null && _appAttributes$appleP5 !== void 0 ? _appAttributes$appleP5 : ["visa", "masterCard", "amex", "discover", "jcb"],
        requiredBillingContactFields: ["name", "postalAddress"],
        requiredShippingContactFields: this.rootStore.platformUtil.PLATFORM_TYPE === common.PlatformType.APP ? ["email"] : ["email", "name"],
        lineItems: [],
        total: {
          label: (_appAttributes$concep3 = (_appAttributes$concep4 = appAttributes.concept) === null || _appAttributes$concep4 === void 0 ? void 0 : _appAttributes$concep4.conceptCodeDesc) !== null && _appAttributes$concep3 !== void 0 ? _appAttributes$concep3 : paypalDisplayName,
          amount: this.toPay.toFixed(2),
          type: "final"
        }
      };

      if (this.requestPhoneNumberFromAppleOrGooglePay) {
        paymentRequest.requiredBillingContactFields.push("phone");
        paymentRequest.requiredShippingContactFields.push("phone");
      }

      if (!this.requestShippingFieldsFromAppleOrGooglePay) {
        delete paymentRequest.requiredShippingContactFields;
      }

      paymentRequest.lineItems.push({
        label: "Subtotal",
        amount: (_this$subTotalWithout2 = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout2 === void 0 ? void 0 : _this$subTotalWithout2.toFixed(2)
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.lineItems.push({
          label: "Coupon Discount",
          amount: discountAmountStr
        });
      }

      if ((_this$orderPriceInfo6 = this.orderPriceInfo) !== null && _this$orderPriceInfo6 !== void 0 && _this$orderPriceInfo6.shipping) {
        paymentRequest.lineItems.push({
          label: "Delivery",
          amount: this.orderPriceInfo.shipping.toFixed(2)
        });
      }

      paymentRequest.lineItems.push({
        label: "Taxes",
        amount: this.orderPriceInfo.tax.toFixed(2)
      });
      paymentRequest.lineItems.push({
        label: "Gratuity",
        amount: this.gratuity ? this.gratuity.toFixed(2) : "0.00"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.lineItems.push({
            label: "Gift Card Ending With " + last4,
            amount: "-" + amountUsed.toFixed(2)
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "payAtRestaurantPayload",
    get: function get() {
      var _this$remainingAuthAn5 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn5.authAmount,
          tipAmount = _this$remainingAuthAn5.tipAmount;
      var payment = {
        amount: authAmount,
        tipAmount: tipAmount
      };
      return {
        inStorePayment: payment
      };
    }
  }, {
    key: "savedCCPaymentPayload",
    get: function get() {
      var _this$selectedCreditC2;

      var userProfile = this.userProfile;
      var savedCard = (_this$selectedCreditC2 = this.selectedCreditCard) === null || _this$selectedCreditC2 === void 0 ? void 0 : _this$selectedCreditC2.card; //prorated

      var _this$remainingAuthAn6 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn6.authAmount,
          tipAmount = _this$remainingAuthAn6.tipAmount;
      var payment = {
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: savedCard.paymentCardToken,
        creditCardType: savedCard.creditCardType,
        expirationMonth: savedCard.expirationMonth,
        expirationYear: savedCard.expirationYear,
        cardAlias: savedCard.paymentCardToken.substring(savedCard.paymentCardToken.length - 4),
        nickName: savedCard.nameOnCard,
        isVaulted: true,
        billingAddress: _objectSpread({
          firstName: userProfile.firstName,
          lastName: userProfile.lastName
        }, savedCard.billingAddress),
        acceptClientType: this.rootStore.acceptClientType
      };

      if (this.paymentCVVEnabled && this.selectedCreditCard.paymentCVV) {
        payment.paymentCVV = this.selectedCreditCard.paymentCVV;
      }

      return {
        vaultedCard: true,
        cardOnFile: true,
        creditCard: payment
      };
    }
  }, {
    key: "formCCPaymentPayload",
    get: function get() {
      var creditCardInfo = this.creditCardInfo;
      var paymentToken = this.creditCardInfo.paymentToken; //prorated

      var _this$remainingAuthAn7 = this.remainingAuthAndTipAmounts,
          authAmount = _this$remainingAuthAn7.authAmount,
          tipAmount = _this$remainingAuthAn7.tipAmount;
      var account = creditCardInfo.cardAccount;
      var payment = {
        isVaulted: false,
        authAmount: authAmount,
        amount: authAmount,
        tipAmount: tipAmount,
        paymentCardToken: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.paymentToken,
        creditCardType: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.cardType,
        expirationMonth: account.card.expMonth,
        expirationYear: account.card.expYear,
        cardAlias: account.card.cardNumber.substring(account.card.cardNumber.length - 4),
        nickName: creditCardInfo.firstName + " " + creditCardInfo.lastName,
        billingAddress: creditCardInfo.billingAddress,
        acceptClientType: this.rootStore.acceptClientType,
        paymentCVV: creditCardInfo === null || creditCardInfo === void 0 ? void 0 : creditCardInfo.cvv
      };

      if (creditCardInfo.isCardCVVValid && creditCardInfo.cvv) {
        payment.paymentCVV = creditCardInfo.cvv;
      }

      if (creditCardInfo.saveCreditCard) {
        payment.saveCardToProfile = true;
        payment["default"] = creditCardInfo.isDefault;
        payment.updateSavedCardMandate = creditCardInfo.agreeDisclaimer;
      }

      return {
        creditCard: payment
      };
    }
  }, {
    key: "gcPaymentPayload",
    get: function get() {
      return this.appliedGiftCards.map(function (gCard) {
        var payment = {
          giftCardNumber: gCard.card.giftCardNumber,
          giftCardType: DPServices.Config.getGiftCardType(),
          authAmount: gCard.proratedAmount,
          amount: gCard.proratedAmount,
          tipAmount: gCard.proratedTip
        };
        return {
          giftCard: payment
        };
      });
    }
  }, {
    key: "isPayAtRest",
    get: function get() {
      return this._activePaymentTab === utils.PaymentMethods.PAY_AT_RESTAURANT;
    }
  }, {
    key: "isSmartPaySelected",
    get: function get() {
      return this.toPay > 0 && this._activePaymentTab === utils.PaymentMethods.ONLINE && (this._activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this._activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY || this._activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY);
    }
  }, {
    key: "isOnlinePaySelected",
    get: function get() {
      return this.toPay > 0 && this._activePaymentTab === utils.PaymentMethods.ONLINE && (this._activeOtherOptionTab === utils.OnlinePaymentTypes.CREDIT_CARD || this._activeOtherOptionTab === utils.OnlinePaymentTypes.PAYPAL || this._activeOtherOptionTab === utils.OnlinePaymentTypes.GOOGLE_PAY || this._activeOtherOptionTab === utils.OnlinePaymentTypes.APPLE_PAY);
    }
  }, {
    key: "bamsCorrelationId",
    get: function get() {
      var _this$sessionToken;

      return (_this$sessionToken = this.sessionToken) === null || _this$sessionToken === void 0 ? void 0 : _this$sessionToken.correlationID;
    }
  }, {
    key: "payPalErrored",
    get: function get() {
      return this._payPalErrored;
    },
    set: function set(val) {
      var _this38 = this;

      runInAction(function () {
        _this38._payPalErrored = val;
      });
    }
  }, {
    key: "applePayErrored",
    get: function get() {
      return this._applePayErrored;
    },
    set: function set(val) {
      var _this39 = this;

      runInAction(function () {
        _this39._applePayErrored = val;
      });
    }
  }, {
    key: "googlePayErrored",
    get: function get() {
      return this._googlePayErrored;
    },
    set: function set(val) {
      var _this40 = this;

      runInAction(function () {
        _this40._googlePayErrored = val;
      });
    }
  }, {
    key: "isPayPalEnabled",
    get: function get() {
      return this._isPayPalEnabled;
    },
    set: function set(isPayPalEnabled) {
      var _this41 = this;

      runInAction(function () {
        _this41._isPayPalEnabled = isPayPalEnabled;
      });
    }
  }, {
    key: "isGiftCardPaymentEnabled",
    get: function get() {
      return this._isGiftCardPaymentEnabled;
    },
    set: function set(isGiftCardPaymentEnabled) {
      var _this42 = this;

      runInAction(function () {
        _this42._isGiftCardPaymentEnabled = isGiftCardPaymentEnabled;
      });
    }
  }, {
    key: "isGooglePayEnabled",
    get: function get() {
      return this._isGooglePayEnabled;
    },
    set: function set(isGooglePayEnabled) {
      var _this43 = this;

      runInAction(function () {
        _this43._isGooglePayEnabled = isGooglePayEnabled;
      });
    }
  }, {
    key: "isApplePayEnabled",
    get: function get() {
      return this._isApplePayEnabled;
    },
    set: function set(isApplePayEnabled) {
      var _this44 = this;

      runInAction(function () {
        _this44._isApplePayEnabled = isApplePayEnabled;
      });
    }
  }, {
    key: "applePaySession",
    get: function get() {
      return this._applePaySession;
    },
    set: function set(applePaySession) {
      var _this45 = this;

      runInAction(function () {
        _this45._applePaySession = applePaySession;
      });
    }
  }, {
    key: "applePayAuthorization",
    get: function get() {
      return this._applePayAuthorization;
    },
    set: function set(applePayAuthorization) {
      var _this46 = this;

      runInAction(function () {
        _this46._applePayAuthorization = applePayAuthorization;
      });
    }
  }, {
    key: "googlePayAuthorization",
    get: function get() {
      return this._googlePayAuthorization;
    },
    set: function set(googlePayAuthorization) {
      var _this47 = this;

      runInAction(function () {
        _this47._googlePayAuthorization = googlePayAuthorization;
      });
    }
  }, {
    key: "fallbackReasonCode",
    get: function get() {
      return this._fallbackReasonCode;
    },
    set: function set(val) {
      var _this48 = this;

      runInAction(function () {
        _this48._fallbackReasonCode = val;
      });
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "showError",
    get: function get() {
      return this._showError;
    }
  }, {
    key: "payPalPaymentRequest",
    get: function get() {
      var _this$subTotalWithout3, _this$orderPriceInfo7;

      var appAttributes = this.rootStore.common.appAttributes;

      var _appAttributes$config3 = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.configs,
          paypalDisplayName = _appAttributes$config3.paypalDisplayName,
          paypalAuthorizationID = _appAttributes$config3.paypalAuthorizationID;

      var paymentRequest = {
        authorization: paypalAuthorizationID,
        displayName: paypalDisplayName,
        offerCredit: false,
        isShippingAddressRequired: false,
        isShippingAddressEditable: true,
        lineItems: [],
        landingPageType: "default"
      };
      paymentRequest.lineItems.push({
        name: "Subtotal",
        unitAmount: (_this$subTotalWithout3 = this.subTotalWithoutItemDiscount) === null || _this$subTotalWithout3 === void 0 ? void 0 : _this$subTotalWithout3.toFixed(2),
        kind: "credit",
        quantity: "1"
      });

      if (this.couponModel.couponDiscount) {
        var couponDiscount = this.couponModel.couponDiscount;
        var discountAmountStr = couponDiscount ? couponDiscount.toFixed(2) : null;
        paymentRequest.lineItems.push({
          name: "Coupon Discount",
          unitAmount: discountAmountStr,
          kind: "credit",
          quantity: "1"
        });
      }

      if ((_this$orderPriceInfo7 = this.orderPriceInfo) !== null && _this$orderPriceInfo7 !== void 0 && _this$orderPriceInfo7.shipping) {
        paymentRequest.lineItems.push({
          name: "Delivery",
          unitAmount: this.orderPriceInfo.shipping.toFixed(2),
          kind: "credit",
          quantity: "1"
        });
      }

      paymentRequest.lineItems.push({
        name: "Taxes",
        unitAmount: this.orderPriceInfo.tax.toFixed(2),
        kind: "credit",
        quantity: "1"
      });
      paymentRequest.lineItems.push({
        name: "Gratuity",
        unitAmount: this.gratuity ? this.gratuity.toFixed(2) : "0.00",
        kind: "credit",
        quantity: "1"
      });

      if (this.isAnyGiftCardSelected) {
        var appliedGiftCards = this.appliedGiftCards;
        appliedGiftCards.forEach(function (uiCard) {
          var amountUsed = uiCard.amountUsed,
              card = uiCard.card;
          var giftCardNumber = card.giftCardNumber;
          var last4 = giftCardNumber.substring(giftCardNumber.length - 4, giftCardNumber.length);
          paymentRequest.lineItems.push({
            name: "Gift Card Ending With " + last4,
            unitAmount: "-" + amountUsed.toFixed(2),
            kind: "credit",
            quantity: "1"
          });
        });
      }

      return paymentRequest;
    }
  }, {
    key: "orderSessionRSARetryCount",
    set: function set(_orderSessionRSARetryCount) {
      var _this49 = this;

      runInAction(function () {
        _this49._orderSessionRSARetryCount = _orderSessionRSARetryCount;
      });
    },
    get: function get() {
      return this._orderSessionRSARetryCount;
    }
  }, {
    key: "isOrderSessionRSARetryCountExhausted",
    get: function get() {
      return this._orderSessionRSARetryCount <= 0;
    }
  }]);

  return Payment;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_rsaFlowEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_activePaymentTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_activeOtherOptionTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_giftCards", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_creditCards", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_subTotalWithoutItemDiscount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_paymentCVV", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_paymentCVVEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_sessionToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_rsaToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_validateToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_encryptionFields", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_isCCPaymentDisabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_payPalErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_applePayErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_googlePayErrored", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_isGCFailureLimitReached", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "giftCardInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_payPalData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_savedGiftCardsLimit", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_orderPriceInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_tippableAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_formSubmitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_isPayPalEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_isGooglePayEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_isApplePayEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_isGiftCardPaymentEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_allowedPaymentMethods", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "PAY_ONLINE";
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_giftCardRecaptchaSiteKey", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_applePaySession", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_applePayAuthorization", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_googlePayAuthorization", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_fallbackReasonCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_flow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_maximumGCAllowedPerOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "_showError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "_requestPhoneNumberFromAppleOrGooglePay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "_orderSessionRSARetryCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "_requestShippingFieldsFromAppleOrGooglePay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "activePaymentTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activePaymentTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "flow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "flow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentCVVEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCVVEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestPhoneNumberFromAppleOrGooglePay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestPhoneNumberFromAppleOrGooglePay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestShippingFieldsFromAppleOrGooglePay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestShippingFieldsFromAppleOrGooglePay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formSubmitted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeOtherOptionTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeOtherOptionTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentCVV", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCVV"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "smartPayOptionsEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "smartPayOptionsEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowedPaymentMethods", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowedPaymentMethods"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onlinePaymentsOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "onlinePaymentsOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCCPaymentDisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCCPaymentDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderPriceInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderPriceInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tippableAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tippableAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subTotalWithoutItemDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subTotalWithoutItemDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rsaToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rsaToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validateToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "encryptionFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "encryptionFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedGiftCardsLimit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedGiftCardsLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumGCAllowedPerOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumGCAllowedPerOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rsaFlowEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rsaFlowEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gratuity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gratuity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNewGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCardRecaptchaSiteKey", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCardRecaptchaSiteKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canAddGiftCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canAddGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "creditCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "creditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCreditCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCreditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCreditCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deSelectCreditCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deSelectCreditCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deSelectGiftCards", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deSelectGiftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSavedCreditCardSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSavedCreditCardSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedCreditCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectedGiftCardsSufficient", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectedGiftCardsSufficient"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedGCRemainingBal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedGCRemainingBal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAnyGiftCardSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnyGiftCardSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMaxGCLimit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMaxGCLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGCFailureLimitReached", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGCFailureLimitReached"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appliedGiftCards", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedGiftCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalGCPaidAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalGCPaidAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalGCAuthAndTipAmounts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalGCAuthAndTipAmounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingAuthAndTipAmounts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingAuthAndTipAmounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toPay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "toPay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingOrderTotal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingOrderTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "amountPaid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "amountPaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTotalIncludingGratuity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotalIncludingGratuity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardAlreadySaved", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardAlreadySaved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paypalPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paypalPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayIsReadyToPayRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayIsReadyToPayRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayPaymentMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayPaymentMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayGatewayMerchantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayGatewayMerchantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payAtRestaurantPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payAtRestaurantPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCCPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedCCPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formCCPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formCCPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gcPaymentPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gcPaymentPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPayAtRest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPayAtRest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSmartPaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSmartPaySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOnlinePaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOnlinePaySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bamsCorrelationId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bamsCorrelationId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applePayErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "applePayErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googlePayErrored", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "googlePayErrored"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fallbackReasonCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fallbackReasonCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payPalPaymentRequest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "payPalPaymentRequest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderSessionRSARetryCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderSessionRSARetryCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderSessionRSARetryCountExhausted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderSessionRSARetryCountExhausted"), _class.prototype)), _class);
export { Payment as default };